Ext.apply(Ext.grid.GridPanel.prototype, {

    // Control+A functionality
    keys:
    {
        key: 'a',
        ctrl: true,
        stopEvent: true,
        handler: function () {
            if (onSelectAll !== undefined)
                onSelectAll();
        }
    },
    listeners: {
        viewready: function (grid) {
            // If the user has over-ridden the viewready event, do not auto-select
            // the first record. The assumption is that the consumer is handling 
            // that in a special-case (for example, the login screen "Select Lab" dialog).
            if (grid.initialConfig && grid.initialConfig.listeners && grid.initialConfig.listeners.viewready)
                return;

            // Do not attempt to auto-select the first row if autoSelectFirstRow === false
            // This matches the AutoSelectFirstRow property of the ViewHelpers/ExtGridPanel control
            if (grid.initialConfig && grid.initialConfig.autoSelectFirstRow === false)
                return;

            // If there are records available, then auto-select the first row
            var store = grid.getStore();
            var count = store.getCount();
            var paging = grid.getBottomToolbar();

            if (count > 0) {

                var selectionModel = grid.getSelectionModel();

                // NOTE: Delay selection to allow consumer code to perform initialization first.
                setTimeout(function () {
                    try {
                        selectionModel.selectFirstRow();
                    } catch (err) { }
                }, 1);

            }
        },
        render: function (grid) {

            var store = grid.getStore();
            var paging = grid.getBottomToolbar();

            // Rebind the store to the paging toolbar.
            var reload = function (action) {

                if (store === undefined) return;
                if (paging === undefined) return;
                if (paging.getXType() != "paging") return;

                // If the store is showing more than 25 items, it is
                // not paged properly
                if (store.getCount() > 25) {
                    // handle ALL non-paged grids.
                    store.totalLength = store.getCount();

                    // if updating the grid in any way - then it's not paged
                    // properly and should be adjusted as follows.
                } else if (action == 'add' || action == 'remove') {
                    // update the total.
                    store.totalLength = store.getCount();
                    // Alternatively, update if totalLength < 25
                }
                // If it's a shaped grid, then do nothing - because it loads properly by default already.

                paging.bindStore(store, true);
            };

            store.on('add', function () { reload('add'); });
            store.on('remove', function () { reload('remove'); });
            store.on('datachanged', function () { reload('load'); });
        }
    }
});

Ext.override(Ext.data.Store, {

});

Ext.grid.PassFailRenderer = function (value, meta, record, rowIndex, colIndex, store) {

    var v = String(___ENFaster(value)).toLowerCase();

    if (v.startsWith('fail indeterminate'))
        return '<img src="/Content/images/icons/small/indeterminatefail.png" />';

    if (v.startsWith('fail'))
        return '<img src="/Content/images/icons/small/fail.png" />';

    if (v.startsWith('pass indeterminate'))
        return '<img src="/Content/images/icons/small/indeterminatepass.png" />';

    if (v.endsWith('marginal'))
        return '<img src="/Content/images/icons/small/pass_yellow.png" />';

    if (v.startsWith('pass'))
        return '<img src="/Content/images/icons/small/pass.png" />';

    return '<img src="" />';    // no icon for any other value not covered above
}


Ext.grid.FloatRenderer = function (value, meta, record, rowIndex, colIndex, store) {

    var field = this.dataIndex.toString();

    // Verify this is formatted correctly.
    if (field.indexOf('_') > 0) {
        // Get the base field information.
        var base = field.substr(0, field.indexOf('_'));
        var scale = base + '_scale';

        // read the scale.
        var scaleDigit = ((record.get(scale) || -1) - 0);
        scaleDigit = (isNaN(scaleDigit) ? 2 : scaleDigit);

        if (scaleDigit >= 0) {
            try {
                // get the scale.
                var num = parseFloat(value);

                if (!isNaN(num)) {
                    // Get the resolution.
                    var result = num.toFixed(scaleDigit);
                    var format = "0,000.";
                    if (Ext.grid.NumberColumn !== undefined && Ext.grid.NumberColumn.prototype.format !== undefined)
                        format = Ext.grid.NumberColumn.prototype.format;

                    // Check for the /i flag.
                    var hasFlag = format.indexOf('i') > 0;

                    // remove digits prior to the decimal separator.
                    for (var i = format.length; i > 0; i--) {
                        if (format.charAt(i) == ',' || format.charAt(i) == '.' || format.charAt(i) == ' ') {
                            format = format.substr(0, i + 1);
                            break;
                        }
                    }

                    while (scaleDigit-- > 0) {
                        format += "0";
                    }

                    // If the i flag was present, re-add it.
                    if (hasFlag)
                        format += "/i";

                    // Now run the number, formatting with our modified value.
                    return Ext.util.Format.number(result, format);
                }
            } catch (ex) { }
        }
    }

    // return normal format.
    return Ext.util.Format.number(value || '');
}

// http://stackoverflow.com/questions/6014593/how-do-i-get-the-selected-index-of-an-extjs-combobox/6015153#6015153
Ext.override(Ext.form.ComboBox, {
    getSelectedIndex: function () {
        var v = this.getValue();
        var r = this.findRecord(this.valueField || this.displayField, v);
        return (this.store.indexOf(r));
    },
    editable: false,
    listeners: {
        afterrender: function (combo) {
            var value = combo.value;
            if (value === null) {
                var store = combo.getStore();
                if (store.getCount()) {
                    combo.setValue(store.getAt(0).id);
                }
            }
        },
        select: function (combo, record, index) {
            if (combo != null) {
                combo.fireEvent("change");
            }
        },
        // The field is technically editable, so that the user can
        // set focus in the control and press DEL or BKSP, but we 
        // don't want them actually editing the data, so disallow 
        // keypresses.
        keypress: function (field, evt) {
            evt.stopEvent();
            evt.preventDefault();
            return false;
        },
        // Check for DELETE and BACKSPACE keys
        keydown: function (field, evt) {
            var key = evt.getKey();
            if (key == 8 || key == 46) {
                evt.stopEvent();
                evt.preventDefault();
                return false;
            }
        }
    },
    setReadOnly: function (readonly) {

        var result = readonly;
        try {

            result = Ext.form.ComboBox.superclass.setReadOnly.call(this);

        }
        catch (err) { }

        this.readOnly = readonly;
        if (readonly)
            this.addClass("readonly");
        else
            this.removeClass("readonly");

        this.validate();

        return result;

    },
    validate: function () {

        if (this.readOnly || this.disabled) {
            // We cannot mark a read-only or disabled field as invalid no matter 
            // what data is stored there, because the user does not have the
            // opportunity to change it. This most frequently happens when the
            // record being displayed already contains invalid data in the 
            // readonly field.
            this.allowBlank = true;
            this.clearInvalid();
        }
        else {
            // If a value is not editable and forceSelection is enabled, 
            // require the user to select a valid value (mark this control
            // invalid for any value not in the list)
            if (!this.editable && this.forceSelection && this.store.getCount()) {

                var currentValue = this.getRawValue();
                // Make sure we handle a blank as a empty string to force drop downs to be required if set
                if (!this.allowBlank && currentValue.trim().length == 0) {
                    this.markInvalid(___("SELECT_VALID_VALUE_FROM_LIST"));
                    return false;
                }

                if (currentValue || !this.allowBlank) {
                    var record = this.findRecord(this.displayField, currentValue);
                    if (!record) {
                        this.markInvalid(___("SELECT_VALID_VALUE_FROM_LIST"));
                        return false;
                    }

                }

            }

        }
        return Ext.form.ComboBox.superclass.validate.call(this);

    }
});

Ext.override(Ext.BasicForm, {
    // Override the submit function.
    doAction: function (action, options) {

        // Make a single point of entry that takes a control key and then does some kind of processing against it.
        function processControl(key) {
            var control = Ext.getCmp(key);

            // for date fields...
            if (control !== undefined && control !== null && control.getXType() == "datefield") {
                options.params = (options.params || {});

                // handle defined, non-null values
                if (control.value !== null && control.value !== undefined) {
                    // Get a UTC date.
                    var today = new Date();
                    var date = new Date(control.value);

                    // Add the current time component.
                    if (date !== undefined && date["setHours"] !== undefined) {

                        // Check if the date is zero zero zero zero.
                        var utc = new Date(date.getUTCTime());
                        if ((utc.getHours() == 0 && utc.getMinutes() == 0 && utc.getSeconds() == 0) ||
                            (date.getHours() == 0 && date.getMinutes() == 0 && date.getSeconds() == 0)) {

                            today.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
                            date = today;
                        }

                        // Get the time of the current control.
                        options.params[key] = date.getTime();

                        control.setDisabled(true);
                        disabledControls[disabledControls.length] = control;
                    }
                }
                // handle undefined & null values
                else {
                    options.params[key] = null;
                }

                return;
            }

            // Check if it's a string field.
            if (key.indexOf('c') !== 0) return;

            if (control !== undefined) {
                // Check if it's a drop down.
                if (control.xtype !== 'combo') return;
                if (control.getValue() == null) return;

                // access the "params" object. Create (or update) the existing
                // field with the combo box's "ID" such that the VALUE being sent
                // is the _filtered_ value (ie: not what is rendered to the user).
                options.params = (options.params || {});
                options.params[key] = control.getValue().toString().trim();

                // disable the drop down control in the interface (prevents the value from being submitted)
                control.setDisabled(true);

                // mark this as needing to be "undone" if the submit failed.
                disabledControls[disabledControls.length] = control;
            }
        }

        // Get a reference to the form object.
        var form = this;
        var formAction = action;

        // update all of the combo box values.
        // NOTE: This is done because of localization. It appears when you make a selection,
        // the combo box doesn't update the "value" property of the associated HTML control.
        // So this is an attempt to make sure that the "value" field is submitted with forms
        // INSTEAD OF THE GetRawValue() field (which is the RENDERED TEXT).
        // *******************************************************
        var fields = form.getFieldValues();
        var disabledControls = [];

        for (var prop in fields) {
            if (fields.hasOwnProperty(prop)) {
                var key = prop;
                processControl(key);
            }
        }

        function reEnable() {
            for (var i = 0; i < disabledControls.length; i++) {
                if (disabledControls[i] !== undefined)
                    disabledControls[i].setDisabled(false);
            }
        }

        // Execute the default action code.
        if (Ext.isString(formAction)) {

            // Store the existing "failure" callback.
            var oldFailure = options["failure"];

            // Create a new one.
            options["failure"] = function () {

                // Undo the "disable combo box"
                reEnable();

                // Invoke the original callback method.
                if (oldFailure !== undefined) {
                    if (arguments.length > 1)
                        oldFailure.call(this, arguments[0], arguments[1]);
                    else
                        oldFailure.call(this, arguments);
                }
            }
            formAction = new Ext.form.Action.ACTION_TYPES[action](form, options);
        }

        // Try to derive the active table name.
        var activeTable = "All";
        try {
            // Each page is *supposed* to initialize itself such that we know
            // in the "editWindow" namespace what table we are dealing with.
            activeTable = editWindow.getActiveTable();
        } catch (exception) { }

        function doDataCheck(callback) {

            // Call the centralized datacheck method for executing.
            DataCheck.Execute(activeTable, undefined, function (success) {
                if (success) {
                    // Re-update the combo box values and date fields.
                    for (var prop in fields) {
                        if (fields.hasOwnProperty(prop)) {
                            var key = prop;
                            processControl(key);
                        }
                    }

                    if (callback !== undefined) {
                        callback();
                    } else {
                        // And send the callback such that, once it completes, the form will be submitted (if successful).
                        if (form.fireEvent('beforeaction', form, formAction) !== false) {
                            form.beforeAction(formAction);

                            // re-gather ext data after DataCheck updates have been applied
                            if (options && options.params && options.params['ExtendedData']) {
                                    options.params['ExtendedData'] = ExtendedData.gatherExtendedData();
                            }

                            formAction.run.defer(100, formAction);
                        }
                    }
                } else {
                    reEnable();
                }
            });
        }

        if ((this.disableAuditing || false) == false) {
            var doAudit = window["auditingEnabled"] || window.parent["auditingEnabled"] || false;
            if (doAudit.toString() == 'true') {
                var self = this;

                // create some callback functions
                function onSuccessReason(reason, callback) {
                    self.addListener("actioncomplete", function (form, action) {
                        // NOTE: This is the entry point for updating the reason.
                        $.ajax({
                            url: '/Auditing/DoUpdateReason',
                            type: 'post',
                            async: false,
                            data: {
                                __RequestVerificationToken: getWindowAntiForgeryTokenValue(),
                                reason: reason,
                                tableName: getTableName()
                            },
                            success: function () {
                                if (callback !== undefined) {
                                    callback();
                                }
                            }
                        });
                        self.removeListener("actioncomplete");
                    });

                    // create an action.
                    if (Ext.isString(action)) {
                        action = new Ext.form.Action.ACTION_TYPES[action](self, options);
                    }

                    // Get the reason and save it in the action.
                    action.cReason = reason;

                    // fire the beforeaction event.
                    if (self.fireEvent('beforeaction', self, action) !== false) {
                        self.beforeAction(action);

                        // re-gather ext data after DataCheck updates have been applied
                        if (options && options.params && options.params['ExtendedData']) {
                            options.params['ExtendedData'] = ExtendedData.gatherExtendedData();
                        }

                        action.run.defer(100, action);
                    }

                    return true;
                }

                function onFail() {
                    Ext.Msg.alert("Attention", "Incorrect password. Please try again.");
                    return false;
                }

                // prompt for a password.
                doDataCheck(function () {
                    if (doAudit.toString() == 'true') {
                        if (auditing)
                            auditing._prompt(onSuccessReason, onFail);
                    } else {
                        onSuccess.call(this);
                    }
                });

            } else {
                // re-use the functionality provided by the auditing feature, just set the reason to NULL and do not prompt for pwd
                var doChangeTracking = (window["changeTrackingEnabled"] || window.parent["changeTrackingEnabled"] || false).toString();
                if (doChangeTracking == 'true') {
                    var self = this;
                    // create some callback functions
                    function onSuccess() {
                        self.addListener("actioncomplete", function (form, action) {
                            // NOTE: This is the entry point for updating the update user for change tracking.
                            $.ajax({
                                url: '/Auditing/DoUpdateReason',
                                type: 'post',
                                async: false,
                                data: {
                                    __RequestVerificationToken: getWindowAntiForgeryTokenValue(),
                                    reason: null,
                                    tableName: getTableName()
                                }
                            });
                            self.removeListener("actioncomplete");
                        });

                        // create an action.
                        if (Ext.isString(action)) {
                            action = new Ext.form.Action.ACTION_TYPES[action](self, options);
                        }

                        // reason is null for change tracking
                        action.cReason = null;

                        // fire the beforeaction event.
                        if (self.fireEvent('beforeaction', self, action) !== false) {
                            self.beforeAction(action);

                            // re-gather ext data after DataCheck updates have been applied
                            if (options && options.params && options.params['ExtendedData']) {
                                options.params['ExtendedData'] = ExtendedData.gatherExtendedData();
                            }

                            action.run.defer(100, action);
                        }

                        return true;
                    }

                    function onFail() {
                        Ext.Msg.alert("Attention", "Failed to update change tracking user.");
                        return false;
                    }

                    doDataCheck(function () {
                        onSuccess.call(this);
                    });
                } else {
                    doDataCheck();
                }
            }
        } else {
            doDataCheck();
        }

        return form;
    }
});


Ext.override(Ext.Panel, {
    // ExtJS has serious problems with nested layouts on TabPanels,
    // See the Ext.TabPanel override below
    forceLayout: true,
    hideMode: 'offsets'
});

Ext.override(Ext.form.FormPanel, {
    listeners: {
        afterlayout: function (self) {
            var tbar = self.getTopToolbar();

            if (self === undefined) return;
            if (tbar === undefined) return;
            if (tbar["getWidth"] === undefined) return;
            if (self["getWidth"] === undefined) return;

            var tbarWidth = tbar.getWidth();
            var selfWidth = self.getWidth();

            if (selfWidth > 0 && tbarWidth < selfWidth) {
                tbar.bubble(function (container) {
                    container.setWidth(selfWidth);
                });
            }
        }
    }
});

Ext.override(Ext.TabPanel, {
    // When deferredRender is set to TRUE, the controls contained in each tab will
    // not be fully instantiated until that tab is viewed by the user or otherwise
    // rendered. This means that an ExtJS Form will not submit data for any tab that
    // has not been viewed. Setting this property to FALSE has an impact on rendering
    // speed (it's slower) but forces the controls to be properly instantiated up-front.
    // Use case resolved by this fix: User loads the Asset/Edit page, edits one or two 
    // fields on the first tab, hits Save.
    // See: http://www.sencha.com/forum/showthread.php?57568-FIXED-1.2.1-FormPanel.isValid%28%29-when-using-nested-TabPanels&p=354335&viewfull=1#post354335
    deferredRender: false,
    forceLayout: true,
    hideMode: 'offsets'
});

Ext.override(Ext.form.Checkbox, {
    setBoxLabel: function (boxLabel) {
        this.boxLabel = boxLabel;
        if (this.rendered) {
            this.wrap.child('.x-form-cb-label').update(boxLabel);
        }
    }
});

Ext.override(Ext.form.DateField, {
    computed: false,
    minValue: new Date(1753, 0, 1, 0, 0, 0, 0),
    setValue: function (v) {

        // If 'v' has a numeric value, then we know it contains
        // ticks instead of a string. This was changed in the framework
        // to be standard. So now instead of parsing the string value, we
        // can parse the ticks and then localize the output.
        // 
        // If however, v is a string. The old system will still work.
        // This should provide the best support for any type of date value.
        if (!isNaN(v) && v !== null && v !== undefined) {
            if (v != 0) {
                // NOTE: do not use parseFloat here because
                // it will render 12/12/2013 into the value 12
                // by truncating the slashes. Which is not the correct
                // ticks for that date.
                // 
                // The timezone code basically makes this assume we're getting a tick formatted for UTC
                // Which should always be the case... ideally...
                v = new Date(Math.round(v));
            } else {
                v = '';
            }
        }

        this.value = v;
        if (this.rendered) {
            this.el.dom.value = (Ext.isEmpty(v) ? '' : Ext.util.Format.date(v));
            this.validate();
        }
        return this;
    },
    listeners: {
        keypress: function (self, evt) {
            if (evt.keyCode == 32) {
                evt.preventDefault();
                return false;
            }
            return true;
        }
    }
});

Ext.override(Ext.form.Field, {
    enableKeyEvents: true,
    setLabel: function (text) {
        if (this.isXType("checkbox")) {
            this.setBoxLabel(text);
        }
        else {
            this.label.update(text + ":");
        }
    },
    setReadOnly: function (readonly) {

        var result = readonly;
        this.readOnly = readonly;

        try {
            if (this.rendered) {
                // Readonly controls weren't setting DOM readOnly property
                this.el.dom.readOnly = readonly;
            }
            if (this.updateEditState) {
                this.updateEditState();
            }
            if (this.isXType("triggerfield")) {
                this.setHideTrigger(readonly);
            }
        }
        catch (err) { }

        if (readonly)
            this.addClass("readonly");
        else
            this.removeClass("readonly");

        this.validate();

        return result;

    }
});

// Implements immediate notification of change events on keystroke rather 
// than waiting for lostfocus event.
Ext.override(Ext.form.TextField, {
    selectOnFocus: true, // Changes the default, which is [false]
    setValue: function (value) {

        // Code as originally written does not work in DateField controls

        // Resetting the [originalValue] value in the setValue() method 
        // works in concert with the [keyup] event to implement a more
        // immediate [change] event notification
        if (this.xtype != "datefield") {
            this.originalValue = value;
            this.clearInvalid();
        }

        // Call the setValue() method on the base class to perform 
        // the actual work.
        Ext.form.TextField.superclass.setValue.call(this, value);

    },
    listeners:
    {
        keyup: function (field, evt) {
            // This is an attempt to get more immediate feedback for 
            // [change] events, instead of waiting until the [onblur]
            // event to fire before we know something has changed.
            if (field.isDirty()) {
                field.fireEvent("change", evt);
            }
        },
        // Note - this is to prevent "double escape key" event
        // in which IE resets all input fields on a page.
        specialkey: function (field, evt) {
            if (evt.getKey() == 27) {
                evt.stopEvent();
                return false;
            }
        }
    }
});

// Hide the refresh button
Ext.override(Ext.PagingToolbar, {
    listeners: {
        render: function (self) {
            if (self.refresh !== undefined) {
                self.refresh.setVisible(false);
            }
        }
    }
});

Ext.override(Ext.Window, {

    maximizable: false,
    minimizable: true,
    resizable: true,

    listeners: {
        move: function (window, x, y) {
            if (window.activated) {
                app.saveWindowPosition(window.name, x, y);
            }
        },
        resize: function (window, width, height) {
            if (window.activated) {
                app.saveWindowSize(window.name, width, height);
            }
        }
    },

    processMessage: function (tag, data) {
        /// <summary>Called by the ClientApp to enable passing of messages between windows</summary>
        /// <param name="tag" type="string">The type of message being passed</param>
        /// <param name="data" type="object">The message data</param>
        try {
            this.fireEvent("message", tag, data);
        }
        catch (err) {
            // This seems to happen primarily when a Window which sends this message has been
            // reloaded. For instance, in an Edit window which reloads the Frame after saving
            // a record and receiving a success response from the server.
            // http://stackoverflow.com/questions/83132/what-causes-the-error-cant-execute-code-from-a-freed-script/2806980#2806980
        }

    }

});

// ExtJS CheckColumn grid plugin: http://dev.sencha.com/deploy/dev/examples/grid/grid-plugins.html
Ext.ns('Ext.ux.grid');
Ext.ux.grid.CheckColumn = Ext.extend(Ext.grid.Column, {

    // This function is being added to the CheckColumn grid item.
    // Really it should maybe be added to Ext.grid.Column instead. But the idea
    // is it takes a record item and returns whether or not the field should be
    // disabled.
    prerender: function (record) {
        return true;
    },

    // The following function is called when the item is clicked.
    handler: function (record, checked) {

    },
    processEvent: function (name, e, grid, rowIndex, colIndex) {
        // Implementing the 'prerender' event to check whether the field
        // should be disabled (per row) instead.
        if (grid !== undefined)
            if (!this.prerender(grid.getStore().getAt(rowIndex)))
                return false;

        if (name == 'mousedown') {
            var record = grid.store.getAt(rowIndex);
            record.set(this.dataIndex, !record.data[this.dataIndex]);
            this.handler(record, record.data[this.dataIndex]);
            return false;
        } else {
            return Ext.grid.ActionColumn.superclass.processEvent.apply(this, arguments);
        }
    },

    renderer: function (v, p, record) {
        // Implementing the 'prerender' event to check whether the field
        // should be disabled (per row) instead.
        if (!this.prerender(record)) {
            p.css += ' cell-disabled';
            return String.format('<div class="x-item-disabled x-grid3-check-col{0}">&#160;</div>', v ? '-on' : '');
        } else {
            p.css += ' x-grid3-check-col-td';
            return String.format('<div class="x-grid3-check-col{0}">&#160;</div>', v ? '-on' : '');
        }
    },

    // Deprecate use as a plugin.
    init: Ext.emptyFn

});

// register ptype. Deprecate.
Ext.preg('checkcolumn', Ext.ux.grid.CheckColumn);

// backwards compat.
Ext.grid.CheckColumn = Ext.ux.grid.CheckColumn;

// register Column xtype
Ext.grid.Column.types.checkcolumn = Ext.ux.grid.CheckColumn;

/**
* @class Ext.ux.TaskBar
* @extends Ext.util.Observable
*/
Ext.ux.TaskBar = function (app) {
    this.app = app;
    this.init();
}

Ext.extend(Ext.ux.TaskBar, Ext.util.Observable, {
    init: function () {

        var width = 10;

        this.tbPanel = new Ext.ux.TaskButtonsPanel({
            el: 'ux-taskbuttons-panel',
            id: 'TaskBarButtons',
            region: 'center'
        });

        var container = new Ext.ux.TaskBarContainer({
            el: 'ux-taskbar',
            layout: 'border',
            items: [this.tbPanel]
        });

        return this;
    },

    addTaskButton: function (win) {
        return this.tbPanel.addButton(win, 'ux-taskbuttons-panel');
    },

    removeTaskButton: function (btn) {
        this.tbPanel.removeButton(btn);
    },

    setActiveButton: function (btn) {
        this.tbPanel.setActiveButton(btn);
    }
});

/**
* @class Ext.ux.TaskBarContainer
* @extends Ext.Container
*/
Ext.ux.TaskBarContainer = Ext.extend(Ext.Container, {
    initComponent: function () {
        Ext.ux.TaskBarContainer.superclass.initComponent.call(this);

        this.el = Ext.get(this.el) || Ext.getBody();
        this.el.setHeight = Ext.emptyFn;
        this.el.setWidth = Ext.emptyFn;
        this.el.setSize = Ext.emptyFn;
        this.el.setStyle({
            overflow: 'hidden',
            margin: '0',
            border: '0 none'
        });
        this.el.dom.scroll = 'no';
        this.allowDomMove = false;
        this.autoWidth = true;
        this.autoHeight = true;
        Ext.EventManager.onWindowResize(this.fireResize, this);
        this.renderTo = this.el;
    },

    fireResize: function (w, h) {
        this.onResize(w, h, w, h);
        this.fireEvent('resize', this, w, h, w, h);
    }
});

/**
* @class Ext.ux.TaskButtonsPanel
* @extends Ext.BoxComponent
*/
Ext.ux.TaskButtonsPanel = Ext.extend(Ext.BoxComponent, {
    activeButton: null,
    enableScroll: true,
    scrollIncrement: 0,
    scrollRepeatInterval: 400,
    scrollDuration: .35,
    animScroll: true,
    resizeButtons: true,
    buttonWidth: 168,
    minButtonWidth: 118,
    buttonMargin: 2,
    buttonWidthSet: false,

    initComponent: function () {
        Ext.ux.TaskButtonsPanel.superclass.initComponent.call(this);
        this.on('resize', this.delegateUpdates);
        this.items = [];

        this.stripWrap = Ext.get(this.el).createChild({
            cls: 'ux-taskbuttons-strip-wrap',
            cn: {
                tag: 'ul', cls: 'ux-taskbuttons-strip'
            }
        });
        this.stripSpacer = Ext.get(this.el).createChild({
            cls: 'ux-taskbuttons-strip-spacer'
        });
        this.strip = new Ext.Element(this.stripWrap.dom.firstChild);

        this.edge = this.strip.createChild({
            tag: 'li',
            cls: 'ux-taskbuttons-edge'
        });
        this.strip.createChild({
            cls: 'x-clear'
        });
    },

    addButton: function (win) {
        var li = this.strip.createChild({ tag: 'li' }, this.edge); // insert before the edge
        var btn = new Ext.ux.TaskBar.TaskButton(win, li);

        this.items.push(btn);

        if (!this.buttonWidthSet) {
            this.lastButtonWidth = btn.container.getWidth();
        }

        this.setActiveButton(btn);
        return btn;
    },

    removeButton: function (btn) {
        var li = document.getElementById(btn.container.id);
        btn.destroy();
        li.parentNode.removeChild(li);

        var s = [];
        for (var i = 0, len = this.items.length; i < len; i++) {
            if (this.items[i] != btn) {
                s.push(this.items[i]);
            }
        }
        this.items = s;

        this.delegateUpdates();
    },

    setActiveButton: function (btn) {
        this.activeButton = btn;
        this.delegateUpdates();
    },

    delegateUpdates: function () {
        /*if(this.suspendUpdates){
		return;
		}*/
        if (this.resizeButtons && this.rendered) {
            this.autoSize();
        }
        if (this.enableScroll && this.rendered) {
            this.autoScroll();
        }
    },

    autoSize: function () {
        var count = this.items.length;
        var ow = this.el.dom.offsetWidth;
        var aw = this.el.dom.clientWidth;

        if (!this.resizeButtons || count < 1 || !aw) { // !aw for display:none
            return;
        }

        var each = Math.max(Math.min(Math.floor((aw - 4) / count) - this.buttonMargin, this.buttonWidth), this.minButtonWidth); // -4 for float errors in IE
        var btns = this.stripWrap.dom.getElementsByTagName('button');

        this.lastButtonWidth = Ext.get(btns[0].id).findParent('li').offsetWidth;

        for (var i = 0, len = btns.length; i < len; i++) {

            var btn = btns[i];

            var tw = Ext.get(btns[i].id).findParent('li').offsetWidth;
            var iw = btn.offsetWidth;

            try {
                btn.style.width = (each - (tw - iw)) + 'px';
            }
            catch (err) {
            }

        }

    },

    autoScroll: function () {
        var count = this.items.length;
        var ow = this.el.dom.offsetWidth;
        var tw = this.el.dom.clientWidth;

        var wrap = this.stripWrap;
        var cw = wrap.dom.offsetWidth;
        var pos = this.getScrollPos();
        var l = this.edge.getOffsetsTo(this.stripWrap)[0] + pos;

        if (!this.enableScroll || count < 1 || cw < 20) { // 20 to prevent display:none issues
            return;
        }

        wrap.setWidth(tw); // moved to here because of problem in Safari

        if (l <= tw) {
            wrap.dom.scrollLeft = 0;
            //wrap.setWidth(tw); moved from here because of problem in Safari
            if (this.scrolling) {
                this.scrolling = false;
                this.el.removeClass('x-taskbuttons-scrolling');
                this.scrollLeft.hide();
                this.scrollRight.hide();
            }
        } else {
            if (!this.scrolling) {
                this.el.addClass('x-taskbuttons-scrolling');
            }
            tw -= wrap.getMargins('lr');
            wrap.setWidth(tw > 20 ? tw : 20);
            if (!this.scrolling) {
                if (!this.scrollLeft) {
                    this.createScrollers();
                } else {
                    this.scrollLeft.show();
                    this.scrollRight.show();
                }
            }
            this.scrolling = true;
            if (pos > (l - tw)) { // ensure it stays within bounds
                wrap.dom.scrollLeft = l - tw;
            } else { // otherwise, make sure the active button is still visible
                this.scrollToButton(this.activeButton, true); // true to animate
            }
            this.updateScrollButtons();
        }
    },

    createScrollers: function () {
        var h = this.el.dom.offsetHeight; //var h = this.stripWrap.dom.offsetHeight;

        // left
        var sl = this.el.insertFirst({
            cls: 'ux-taskbuttons-scroller-left'
        });
        sl.setHeight(h);
        sl.addClassOnOver('ux-taskbuttons-scroller-left-over');
        this.leftRepeater = new Ext.util.ClickRepeater(sl, {
            interval: this.scrollRepeatInterval,
            handler: this.onScrollLeft,
            scope: this
        });
        this.scrollLeft = sl;

        // right
        var sr = this.el.insertFirst({
            cls: 'ux-taskbuttons-scroller-right'
        });
        sr.setHeight(h);
        sr.addClassOnOver('ux-taskbuttons-scroller-right-over');
        this.rightRepeater = new Ext.util.ClickRepeater(sr, {
            interval: this.scrollRepeatInterval,
            handler: this.onScrollRight,
            scope: this
        });
        this.scrollRight = sr;
    },

    getScrollWidth: function () {
        return this.edge.getOffsetsTo(this.stripWrap)[0] + this.getScrollPos();
    },

    getScrollPos: function () {
        return parseInt(this.stripWrap.dom.scrollLeft, 10) || 0;
    },

    getScrollArea: function () {
        return parseInt(this.stripWrap.dom.clientWidth, 10) || 0;
    },

    getScrollAnim: function () {
        return {
            duration: this.scrollDuration,
            callback: this.updateScrollButtons,
            scope: this
        };
    },

    getScrollIncrement: function () {
        return (this.scrollIncrement || this.lastButtonWidth + 2);
    },

    /* getBtnEl : function(item){
	return document.getElementById(item.id);
	}, */

    scrollToButton: function (item, animate) {
        item = item.el.dom.parentNode; // li
        if (!item) { return; }
        var el = item; //this.getBtnEl(item);
        var pos = this.getScrollPos(), area = this.getScrollArea();
        var left = Ext.fly(el).getOffsetsTo(this.stripWrap)[0] + pos;
        var right = left + el.offsetWidth;
        if (left < pos) {
            this.scrollTo(left, animate);
        } else if (right > (pos + area)) {
            this.scrollTo(right - area, animate);
        }
    },

    scrollTo: function (pos, animate) {
        this.stripWrap.scrollTo('left', pos, animate ? this.getScrollAnim() : false);
        if (!animate) {
            this.updateScrollButtons();
        }
    },

    onScrollRight: function () {
        var sw = this.getScrollWidth() - this.getScrollArea();
        var pos = this.getScrollPos();
        var s = Math.min(sw, pos + this.getScrollIncrement());
        if (s != pos) {
            this.scrollTo(s, this.animScroll);
        }
    },

    onScrollLeft: function () {
        var pos = this.getScrollPos();
        var s = Math.max(0, pos - this.getScrollIncrement());
        if (s != pos) {
            this.scrollTo(s, this.animScroll);
        }
    },

    updateScrollButtons: function () {
        var pos = this.getScrollPos();
        this.scrollLeft[pos == 0 ? 'addClass' : 'removeClass']('ux-taskbuttons-scroller-left-disabled');
        this.scrollRight[pos >= (this.getScrollWidth() - this.getScrollArea()) ? 'addClass' : 'removeClass']('ux-taskbuttons-scroller-right-disabled');
    }
});



/**
* @class Ext.ux.TaskBar.TaskButton
* @extends Ext.Button
*/
Ext.ux.TaskBar.TaskButton = function (win, el) {
    this.win = win;
    Ext.ux.TaskBar.TaskButton.superclass.constructor.call(this, {
        iconCls: win.iconCls,
        text: Ext.util.Format.ellipsis(win.title, 25),
        renderTo: el,
        handler: function () {
            if (win.minimized || win.hidden) {
                win.show();
            } else if (win == win.manager.getActive()) {
                win.minimize();
            } else {
                win.toFront();
            }
        },
        clickEvent: 'mousedown',
        template: new Ext.Template(
            '<table cellspacing="0" class="x-btn {3}"><tbody><tr>',
            '<td class="ux-taskbutton-left"><i>&#160;</i></td>',
            '<td class="ux-taskbutton-center"><em class="{5} unselectable="on">',
            '<button class="x-btn-text {2}" type="{1}" style="height:28px;">{0}</button>',
            '</em></td>',
            '<td class="ux-taskbutton-right"><i>&#160;</i></td>',
            "</tr></tbody></table>")
    });
};

Ext.extend(Ext.ux.TaskBar.TaskButton, Ext.Button, {
    setText: function (text) {
        text = Ext.util.Format.ellipsis(text, 25, true);
        if (this.el) {
            this.btnEl.update(text || '&#160;');
            this.setButtonClass();
        }
        this.doAutoWidth();
        return this;
    },
    onRender: function () {
        Ext.ux.TaskBar.TaskButton.superclass.onRender.apply(this, arguments);

        this.cmenu = new Ext.menu.Menu({
            items: [{
                text: 'Restore',
                handler: function () {
                    if (!this.win.isVisible()) {
                        this.win.show();
                    } else {
                        this.win.restore();
                    }
                },
                scope: this
            }, {
                text: 'Minimize',
                handler: this.win.minimize,
                scope: this.win
            }, {
                text: 'Maximize',
                handler: this.win.maximize,
                scope: this.win
            }, '-', {
                text: 'Close',
                handler: this.closeWin.createDelegate(this, this.win, true),
                scope: this.win
            }]
        });

        this.cmenu.on('beforeshow', function () {
            var items = this.cmenu.items.items;
            var w = this.win;
            items[0].setDisabled(w.maximized !== true && w.hidden !== true);
            items[1].setDisabled(w.minimized === true);
            items[2].setDisabled(w.maximized === true || w.hidden === true);
        }, this);

        this.el.on('contextmenu', function (e) {
            e.stopEvent();
            //			if( !this.cmenu.el )
            //			{
            //				this.cmenu.render();
            //			}
            //			var xy = e.getXY();
            //			xy[1] -= this.cmenu.el.getHeight();
            //			this.cmenu.showAt( xy );
        }, this);
    },

    closeWin: function (cMenu, e, win) {
        if (!win.isVisible()) {
            win.show();
        } else {
            win.restore();
        }
        win.close();
    }
});

Ext.Desktop = function (app) {

    // NOTE: It may look odd to have an additional reference to the [this] object, but 
    // do not remove it unless you understand Javascript's lexical scoping rules and know
    // of a better workaround for the issues this is intended to solve.
    //		http://mark-story.com/posts/view/picking-up-javascript-closures-and-lexical-scoping
    var thisDesktop = this;

    this.taskbar = new Ext.ux.TaskBar(app);
    var taskbar = this.taskbar;

    this.xTickSize = this.yTickSize = 1;

    var desktopEl = Ext.get('x-desktop');
    var menubarEl = Ext.get('main-toolbar');
    var shortcuts = Ext.get('x-shortcuts');

    var windows = new Ext.WindowGroup();
    var activeWindow;

    function minimizeWin(win) {
        win.minimized = true;
        win.hide();
    }

    function markActive(win) {
        if (activeWindow && activeWindow != win) {
            markInactive(activeWindow);
        }
        activeWindow = win;
        taskbar.setActiveButton(win.taskButton);
        Ext.fly(win.taskButton.el).addClass('active-win');
        win.minimized = false;
        win.toFront();
    }

    function markInactive(win) {
        if (win == activeWindow) {
            activeWindow = null;
            Ext.fly(win.taskButton.el).removeClass('active-win');
        }
    }

    function removeWin(win) {
        taskbar.removeTaskButton(win.taskButton);
        thisDesktop.layout();
    }

    this.layout = function () {
        var taskbarEl = Ext.get('ux-taskbar');
        desktopEl.setHeight(Ext.lib.Dom.getViewHeight() - menubarEl.getHeight() - taskbarEl.getHeight());
    }

    this.createWindow = function (config, cls) {

        var win = new (cls || Ext.Window)(
            Ext.applyIf(config || {},
                {
                    renderTo: desktopEl,
                    manager: windows,
                    minimizable: true,
                    maximizable: true
                })
        );

        win.dd.xTickSize = this.xTickSize;
        win.dd.yTickSize = this.yTickSize;

        if (win.resizer) {
            win.resizer.widthIncrement = this.xTickSize;
            win.resizer.heightIncrement = this.yTickSize;
        }

        win.render(desktopEl);
        win.taskButton = taskbar.addTaskButton(win);

        win.cmenu = new Ext.menu.Menu({
            items: [
            ]
        });

        win.animateTarget = win.taskButton.el;

        win.on({
            'activate': {
                fn: markActive
            },
            'beforeshow': {
                fn: markActive
            },
            'deactivate': {
                fn: markInactive
            },
            'minimize': {
                fn: minimizeWin
            },
            'close': {
                fn: removeWin
            }
        });

        thisDesktop.layout();
        return win;

    };

    this.markActive = markActive;

    this.getActiveWindow = function () {
        return activeWindow;
    };

    this.getManager = function () {
        return windows;
    };

    this.getWindow = function (id) {
        return windows.get(id);
    };

    this.getWinWidth = function () {
        var width = Ext.lib.Dom.getViewWidth();
        return width < 250 ? 250 : width;
    };

    this.getWinHeight = function () {
        var height = (Ext.lib.Dom.getViewHeight() - menubarEl.getHeight() - taskbarEl.getHeight());
        return height < 100 ? 100 : height;
    };

    this.getWinX = function (width) {
        return (Ext.lib.Dom.getViewWidth() - width) / 2;
    };

    this.getWinY = function (height) {
        return (Ext.lib.Dom.getViewHeight() - menubarEl.getHeight() - taskbarEl.getHeight() - height) / 2;
    };

    this.setTickSize = function (xTickSize, yTickSize) {
        this.xTickSize = xTickSize;
        if (arguments.length == 1) {
            this.yTickSize = xTickSize;
        } else {
            this.yTickSize = yTickSize;
        }
        windows.each(function (win) {
            win.dd.xTickSize = this.xTickSize;
            win.dd.yTickSize = this.yTickSize;
            win.resizer.widthIncrement = this.xTickSize;
            win.resizer.heightIncrement = this.yTickSize;
        },
            this);
    };

    this.cascade = function () {
        var x = 0,
            y = 0;
        windows.each(function (win) {
            if (win.isVisible() && !win.maximized) {
                win.setPosition(x, y);
                x += 20;
                y += 20;
            }
        },
            this);
    };

    this.tile = function () {
        var availWidth = desktopEl.getWidth(true);
        var x = this.xTickSize;
        var y = this.yTickSize;
        var nextY = y;
        windows.each(function (win) {
            if (win.isVisible() && !win.maximized) {
                var w = win.el.getWidth();

                // Wrap to next row if we are not at the line start and this Window will go off the end
                if ((x > this.xTickSize) && (x + w > availWidth)) {
                    x = this.xTickSize;
                    y = nextY;
                }

                win.setPosition(x, y);
                x += w + this.xTickSize;
                nextY = Math.max(nextY, y + win.el.getHeight() + this.yTickSize);
            }
        },
            this);
    };

    this.contextMenu = new Ext.menu.Menu({
        items: [{
            text: 'Tile',
            handler: this.tile,
            scope: this
        },
        {
            text: 'Cascade',
            handler: this.cascade,
            scope: this
        }]
    });

    desktopEl.on('contextmenu',
        function (e) {
            e.stopEvent();
            //			this.contextMenu.showAt( e.getXY() );
        },
        this
    );

    Ext.EventManager.onWindowResize(function () { thisDesktop.layout(); });
    this.layout();

};

/*!
* Ext JS Library 3.3.1
* Copyright(c) 2006-2010 Sencha Inc.
* licensing@sencha.com
* http://www.sencha.com/license
*/
/* 
http://dev.sencha.com/deploy/dev/examples/statusbar/statusbar-demo.html
*/
Ext.ux.StatusBar = Ext.extend(Ext.Toolbar, {
    cls: 'x-statusbar',
    busyIconCls: 'x-status-busy',
    busyText: 'Loading...',
    autoClear: 5000,
    emptyText: '&nbsp;',
    activeThreadId: 0,

    // private
    initComponent: function () {
        if (this.statusAlign == 'right') {
            this.cls += ' x-status-right';
        }
        Ext.ux.StatusBar.superclass.initComponent.call(this);
    },

    // private
    afterRender: function () {
        Ext.ux.StatusBar.superclass.afterRender.call(this);

        var right = this.statusAlign == 'right';
        this.currIconCls = this.iconCls || this.defaultIconCls;
        this.statusEl = new Ext.Toolbar.TextItem({
            cls: 'x-status-text ' + (this.currIconCls || ''),
            text: this.text || this.defaultText || ''
        });

        if (right) {
            this.add('->');
            this.add(this.statusEl);
        } else {
            this.insert(0, this.statusEl);
            this.insert(1, '->');
        }
        this.doLayout();
    },

    setStatus: function (o) {
        o = o || {};

        if (typeof o == 'string') {
            o = { text: o };
        }
        if (o.text !== undefined) {
            this.setText(o.text);
        }
        if (o.iconCls !== undefined) {
            this.setIcon(o.iconCls);
        }

        if (o.clear) {
            var c = o.clear,
                wait = this.autoClear,
                defaults = { useDefaults: true, anim: true };

            if (typeof c == 'object') {
                c = Ext.applyIf(c, defaults);
                if (c.wait) {
                    wait = c.wait;
                }
            } else if (typeof c == 'number') {
                wait = c;
                c = defaults;
            } else if (typeof c == 'boolean') {
                c = defaults;
            }

            c.threadId = this.activeThreadId;
            this.clearStatus.defer(wait, this, [c]);
        }
        return this;
    },

    clearStatus: function (o) {
        o = o || {};

        if (o.threadId && o.threadId !== this.activeThreadId) {
            // this means the current call was made internally, but a newer
            // thread has set a message since this call was deferred.  Since
            // we don't want to overwrite a newer message just ignore.
            return this;
        }

        var text = o.useDefaults ? this.defaultText : this.emptyText,
            iconCls = o.useDefaults ? (this.defaultIconCls ? this.defaultIconCls : '') : '';

        if (o.anim) {
            // animate the statusEl Ext.Element
            this.statusEl.el.fadeOut({
                remove: false,
                useDisplay: true,
                scope: this,
                callback: function () {
                    this.setStatus({
                        text: text,
                        iconCls: iconCls
                    });

                    this.statusEl.el.show();
                }
            });
        } else {
            // hide/show the el to avoid jumpy text or icon
            this.statusEl.hide();
            this.setStatus({
                text: text,
                iconCls: iconCls
            });
            this.statusEl.show();
        }
        return this;
    },

    setText: function (text) {
        this.activeThreadId++;
        this.text = text || '';
        if (this.rendered) {
            this.statusEl.setText(this.text);
        }
        return this;
    },

    getText: function () {
        return this.text;
    },

    setIcon: function (cls) {
        this.activeThreadId++;
        cls = cls || '';

        if (this.rendered) {
            if (this.currIconCls) {
                this.statusEl.removeClass(this.currIconCls);
                this.currIconCls = null;
            }
            if (cls.length > 0) {
                this.statusEl.addClass(cls);
                this.currIconCls = cls;
            }
        } else {
            this.currIconCls = cls;
        }
        return this;
    },

    showBusy: function (o) {
        if (typeof o == 'string') {
            o = { text: o };
        }
        o = Ext.applyIf(o || {}, {
            text: this.busyText,
            iconCls: this.busyIconCls
        });
        return this.setStatus(o);
    }
});

Ext.reg('statusbar', Ext.ux.StatusBar);

// vim: ts=4:sw=4:nu:fdc=2:nospell
/**
* Ext.ux.form.XCheckbox - checkbox with configurable submit values
*
* @author  Ing. Jozef Sakalos
* @version $Id: Ext.ux.form.XCheckbox.js 441 2009-01-12 11:10:10Z jozo $
* @date    10. February 2008
*
*
* @license Ext.ux.form.XCheckbox is licensed under the terms of
* the Open Source LGPL 3.0 license.  Commercial use is permitted to the extent
* that the code/component(s) do NOT become part of another Open Source or Commercially
* licensed development library or toolkit without explicit permission.
* 
* License details: http://www.gnu.org/licenses/lgpl.html
* Found at: http://www.sencha.com/forum/showthread.php?25924-XCheckbox-A-nicer-checkbox-always-submitting-configurable-values&p=211041#post211041
*/

/*global Ext */

/**
* @class Ext.ux.XCheckbox
* @extends Ext.form.Checkbox
*/
Ext.ns('Ext.ux.form');
Ext.ux.form.XCheckbox = Ext.extend(Ext.form.Checkbox, {

    submitOffValue: '0',
    submitOnValue: '-1',

    onRender: function () {

        this.inputValue = this.submitOnValue;

        // call parent
        Ext.ux.form.XCheckbox.superclass.onRender.apply(this, arguments);

        // create hidden field that is submitted if checkbox is not checked
        this.hiddenField = this.wrap.insertFirst({ tag: 'input', type: 'hidden' });

        // support tooltip
        if (this.tooltip && this.imageEl) {
            this.imageEl.set({ qtip: this.tooltip });
        }

        // update value of hidden field
        this.updateHidden();

    },

    /**
	* Calls parent and updates hiddenField
	* @private
	*/
    setValue: function (v) {
        v = this.convertValue(v);
        this.updateHidden(v);
        Ext.ux.form.XCheckbox.superclass.setValue.apply(this, arguments);
    },

    /**
	* Updates hiddenField
	* @private
	*/
    updateHidden: function (v) {
        v = undefined !== v ? v : this.checked;
        v = this.convertValue(v);
        if (this.hiddenField) {
            this.hiddenField.dom.value = v ? this.submitOnValue : this.submitOffValue;
            this.hiddenField.dom.name = v ? '' : this.getId();
            //this.el.dom.name = v ? this.getId() : "";
        }
    },

    /**
	* Converts value to boolean
	* @private
	*/
    convertValue: function (v) {
        return (v === true || v === 'true' || v === this.submitOnValue || String(v).toLowerCase() === 'on' || +v != 0);
    }

});    // eo extend
Ext.reg('xcheckbox', Ext.ux.form.XCheckbox);

// Enables the horizontal scrollbar in a TextArea by allowing wordwrap to be disabled
Ext.override(Ext.form.TextArea, {
    initComponent: Ext.form.TextArea.prototype.initComponent.createSequence(function () {
        Ext.applyIf(this, { wordWrap: true });
    }),

    onRender: Ext.form.TextArea.prototype.onRender.createSequence(function (ct, position) {
        this.el.setOverflow('auto');
        if (this.wordWrap === false) {
            if (!Ext.isIE) {
                this.el.set({ wrap: 'off' })
            } else {
                this.el.dom.wrap = 'off';
            }
        }
        if (this.preventScrollbars === true) {
            this.el.setStyle('overflow', 'hidden');
        }
    })
});

// Gets rid of that damned stupid default behavior of making a menu
// go away when you click a menu item that has an attached submenu.
Ext.override(Ext.menu.Menu, {
    onClick: function (e) {
        var t = this.findTargetItem(e);
        if (t) {
            if (t.menu) {
                t.expandMenu();
                top.stopEvent(e);
                top.cancelEvent(e);
                return false;
            }
            else if (t.onClick) {
                t.onClick(e);
                this.fireEvent("click", this, t, e);
            }
        }
    }
});

////////////////////////////////
/// ExtJS TreeGrid Extension ///
////////////////////////////////
/// http://dev.sencha.com/deploy/ext-3.3.1/examples/treegrid/treegrid.html
////////////////////////////////

/*!
* Ext JS Library 3.3.1
* Copyright(c) 2006-2010 Sencha Inc.
* licensing@sencha.com
* http://www.sencha.com/license
*/
Ext.ns('Ext.ux.tree');

/**
* @class Ext.ux.tree.TreeGridSorter
* @extends Ext.tree.TreeSorter
* Provides sorting of nodes in a {@link Ext.ux.tree.TreeGrid}.  The TreeGridSorter automatically monitors events on the
* associated TreeGrid that might affect the tree's sort order (beforechildrenrendered, append, insert and textchange).
* Example usage:<br />
* <pre><code>
new Ext.ux.tree.TreeGridSorter(myTreeGrid, {
folderSort: true,
dir: "desc",
sortType: function(node) {
// sort by a custom, typed attribute:
return parseInt(node.id, 10);
}
});
</code></pre>
* @constructor
* @param {TreeGrid} tree
* @param {Object} config
*/
Ext.ux.tree.TreeGridSorter = Ext.extend(Ext.tree.TreeSorter, {
    /**
	* @cfg {Array} sortClasses The CSS classes applied to a header when it is sorted. (defaults to <tt>['sort-asc', 'sort-desc']</tt>)
	*/
    sortClasses: ['sort-asc', 'sort-desc'],
    /**
	* @cfg {String} sortAscText The text displayed in the 'Sort Ascending' menu item (defaults to <tt>'Sort Ascending'</tt>)
	*/
    sortAscText: 'Sort Ascending',
    /**
	* @cfg {String} sortDescText The text displayed in the 'Sort Descending' menu item (defaults to <tt>'Sort Descending'</tt>)
	*/
    sortDescText: 'Sort Descending',

    constructor: function (tree, config) {
        if (!Ext.isObject(config)) {
            config = {
                property: tree.columns[0].dataIndex || 'text',
                folderSort: true
            }
        }

        Ext.ux.tree.TreeGridSorter.superclass.constructor.apply(this, arguments);

        this.tree = tree;
        tree.on('headerclick', this.onHeaderClick, this);
        tree.ddAppendOnly = true;

        var me = this;
        this.defaultSortFn = function (n1, n2) {

            var desc = me.dir && me.dir.toLowerCase() == 'desc',
                prop = me.property || 'text',
                sortType = me.sortType,
                caseSensitive = me.caseSensitive === true,
                leafAttr = me.leafAttr || 'leaf',
                attr1 = n1.attributes,
                attr2 = n2.attributes;

            if (me.folderSort) {
                if (attr1[leafAttr] && !attr2[leafAttr]) {
                    return 1;
                }
                if (!attr1[leafAttr] && attr2[leafAttr]) {
                    return -1;
                }
            }
            var prop1 = attr1[prop],
                prop2 = attr2[prop],
                v1 = sortType ? sortType(prop1) : (caseSensitive ? prop1 : prop1.toUpperCase());
            v2 = sortType ? sortType(prop2) : (caseSensitive ? prop2 : prop2.toUpperCase());

            if (v1 < v2) {
                return desc ? +1 : -1;
            } else if (v1 > v2) {
                return desc ? -1 : +1;
            } else {
                return 0;
            }
        };

        tree.on('afterrender', this.onAfterTreeRender, this, { single: true });
        tree.on('headermenuclick', this.onHeaderMenuClick, this);
    },

    onAfterTreeRender: function () {
        if (this.tree.hmenu) {
            this.tree.hmenu.insert(0,
                { itemId: 'asc', text: this.sortAscText, cls: 'xg-hmenu-sort-asc' },
                { itemId: 'desc', text: this.sortDescText, cls: 'xg-hmenu-sort-desc' }
            );
        }
        this.updateSortIcon(0, 'asc');
    },

    onHeaderMenuClick: function (c, id, index) {
        if (id === 'asc' || id === 'desc') {
            this.onHeaderClick(c, null, index);
            return false;
        }
    },

    onHeaderClick: function (c, el, i) {
        if (c && !this.tree.headersDisabled) {
            var me = this;

            me.property = c.dataIndex;
            me.dir = c.dir = (c.dir === 'desc' ? 'asc' : 'desc');
            me.sortType = c.sortType;
            me.caseSensitive === Ext.isBoolean(c.caseSensitive) ? c.caseSensitive : this.caseSensitive;
            me.sortFn = c.sortFn || this.defaultSortFn;

            this.tree.root.cascade(function (n) {
                if (!n.isLeaf()) {
                    me.updateSort(me.tree, n);
                }
            });

            this.updateSortIcon(i, c.dir);
        }
    },

    // private
    updateSortIcon: function (col, dir) {
        var sc = this.sortClasses,
            hds = this.tree.innerHd.select('td').removeClass(sc);
        hds.item(col).addClass(sc[dir == 'desc' ? 1 : 0]);
    }
});

/*!
* Ext JS Library 3.3.1
* Copyright(c) 2006-2010 Sencha Inc.
* licensing@sencha.com
* http://www.sencha.com/license
*/
/**
* @class Ext.tree.ColumnResizer
* @extends Ext.util.Observable
*/
Ext.tree.ColumnResizer = Ext.extend(Ext.util.Observable, {
    /**
	* @cfg {Number} minWidth The minimum width the column can be dragged to.
	* Defaults to <tt>14</tt>.
	*/
    minWidth: 14,

    constructor: function (config) {
        Ext.apply(this, config);
        Ext.tree.ColumnResizer.superclass.constructor.call(this);
    },

    init: function (tree) {
        this.tree = tree;
        tree.on('render', this.initEvents, this);
    },

    initEvents: function (tree) {
        tree.mon(tree.innerHd, 'mousemove', this.handleHdMove, this);
        this.tracker = new Ext.dd.DragTracker({
            onBeforeStart: this.onBeforeStart.createDelegate(this),
            onStart: this.onStart.createDelegate(this),
            onDrag: this.onDrag.createDelegate(this),
            onEnd: this.onEnd.createDelegate(this),
            tolerance: 3,
            autoStart: 300
        });
        this.tracker.initEl(tree.innerHd);
        tree.on('beforedestroy', this.tracker.destroy, this.tracker);
    },

    handleHdMove: function (e, t) {
        var hw = 5,
            x = e.getPageX(),
            hd = e.getTarget('.x-treegrid-hd', 3, true);

        if (hd) {
            var r = hd.getRegion(),
                ss = hd.dom.style,
                pn = hd.dom.parentNode;

            if (x - r.left <= hw && hd.dom !== pn.firstChild) {
                var ps = hd.dom.previousSibling;
                while (ps && Ext.fly(ps).hasClass('x-treegrid-hd-hidden')) {
                    ps = ps.previousSibling;
                }
                if (ps) {
                    this.activeHd = Ext.get(ps);
                    ss.cursor = Ext.isWebKit ? 'e-resize' : 'col-resize';
                }
            } else if (r.right - x <= hw) {
                var ns = hd.dom;
                while (ns && Ext.fly(ns).hasClass('x-treegrid-hd-hidden')) {
                    ns = ns.previousSibling;
                }
                if (ns) {
                    this.activeHd = Ext.get(ns);
                    ss.cursor = Ext.isWebKit ? 'w-resize' : 'col-resize';
                }
            } else {
                delete this.activeHd;
                ss.cursor = '';
            }
        }
    },

    onBeforeStart: function (e) {
        this.dragHd = this.activeHd;
        return !!this.dragHd;
    },

    onStart: function (e) {
        this.dragHeadersDisabled = this.tree.headersDisabled;
        this.tree.headersDisabled = true;
        this.proxy = this.tree.body.createChild({ cls: 'x-treegrid-resizer' });
        this.proxy.setHeight(this.tree.body.getHeight());

        var x = this.tracker.getXY()[0];

        this.hdX = this.dragHd.getX();
        this.hdIndex = this.tree.findHeaderIndex(this.dragHd);

        this.proxy.setX(this.hdX);
        this.proxy.setWidth(x - this.hdX);

        this.maxWidth = this.tree.outerCt.getWidth() - this.tree.innerBody.translatePoints(this.hdX).left;
    },

    onDrag: function (e) {
        var cursorX = this.tracker.getXY()[0];
        this.proxy.setWidth((cursorX - this.hdX).constrain(this.minWidth, this.maxWidth));
    },

    onEnd: function (e) {
        var nw = this.proxy.getWidth(),
            tree = this.tree,
            disabled = this.dragHeadersDisabled;

        this.proxy.remove();
        delete this.dragHd;

        tree.columns[this.hdIndex].width = nw;
        tree.updateColumnWidths();

        setTimeout(function () {
            tree.headersDisabled = disabled;
        }, 100);
    }
});

/*!
* Ext JS Library 3.3.1
* Copyright(c) 2006-2010 Sencha Inc.
* licensing@sencha.com
* http://www.sencha.com/license
*/
/**
* @class Ext.ux.tree.TreeGridNodeUI
* @extends Ext.tree.TreeNodeUI
*/
Ext.ux.tree.TreeGridNodeUI = Ext.extend(Ext.tree.TreeNodeUI, {
    isTreeGridNodeUI: true,

    renderElements: function (n, a, targetNode, bulkRender) {
        var t = n.getOwnerTree(),
            cols = t.columns,
            c = cols[0],
            i, buf, len;

        this.indentMarkup = n.parentNode ? n.parentNode.ui.getChildIndent() : '';

        buf = [
            '<tbody class="x-tree-node">',
            '<tr ext:tree-node-id="', n.id, '" class="x-tree-node-el x-tree-node-leaf ', a.cls, '">',
            '<td class="x-treegrid-col">',
            '<span class="x-tree-node-indent">', this.indentMarkup, "</span>",
            '<img src="', this.emptyIcon, '" class="x-tree-ec-icon x-tree-elbow" />',
            '<img src="', a.icon || this.emptyIcon, '" class="x-tree-node-icon', (a.icon ? " x-tree-node-inline-icon" : ""), (a.iconCls ? " " + a.iconCls : ""), '" unselectable="on" />',
            '<a hidefocus="on" class="x-tree-node-anchor" href="', a.href ? a.href : '#', '" tabIndex="1" ',
            a.hrefTarget ? ' target="' + a.hrefTarget + '"' : '', '>',
            '<span unselectable="on">', (c.tpl ? c.tpl.apply(a) : a[c.dataIndex] || c.text), '</span></a>',
            '</td>'
        ];

        for (i = 1, len = cols.length; i < len; i++) {
            c = cols[i];
            buf.push(
                '<td class="x-treegrid-col ', (c.cls ? c.cls : ''), '">',
                '<div unselectable="on" class="x-treegrid-text"', (c.align ? ' style="text-align: ' + c.align + ';"' : ''), '>',
                (c.tpl ? c.tpl.apply(a) : a[c.dataIndex]),
                '</div>',
                '</td>'
            );
        }

        buf.push(
            '</tr><tr class="x-tree-node-ct"><td colspan="', cols.length, '">',
            '<table class="x-treegrid-node-ct-table" cellpadding="0" cellspacing="0" style="table-layout: fixed; display: none; width: ', t.innerCt.getWidth(), 'px;"><colgroup>'
        );
        for (i = 0, len = cols.length; i < len; i++) {
            buf.push('<col style="width: ', (cols[i].hidden ? 0 : cols[i].width), 'px;" />');
        }
        buf.push('</colgroup></table></td></tr></tbody>');

        if (bulkRender !== true && n.nextSibling && n.nextSibling.ui.getEl()) {
            this.wrap = Ext.DomHelper.insertHtml("beforeBegin", n.nextSibling.ui.getEl(), buf.join(''));
        } else {
            this.wrap = Ext.DomHelper.insertHtml("beforeEnd", targetNode, buf.join(''));
        }

        this.elNode = this.wrap.childNodes[0];
        this.ctNode = this.wrap.childNodes[1].firstChild.firstChild;
        var cs = this.elNode.firstChild.childNodes;
        this.indentNode = cs[0];
        this.ecNode = cs[1];
        this.iconNode = cs[2];
        this.anchor = cs[3];
        this.textNode = cs[3].firstChild;
    },

    // private
    animExpand: function (cb) {
        this.ctNode.style.display = "";
        Ext.ux.tree.TreeGridNodeUI.superclass.animExpand.call(this, cb);
    }
});

Ext.ux.tree.TreeGridRootNodeUI = Ext.extend(Ext.tree.TreeNodeUI, {
    isTreeGridNodeUI: true,

    // private
    render: function () {
        if (!this.rendered) {
            this.wrap = this.ctNode = this.node.ownerTree.innerCt.dom;
            this.node.expanded = true;
        }

        if (Ext.isWebKit) {
            // weird table-layout: fixed issue in webkit
            var ct = this.ctNode;
            ct.style.tableLayout = null;
            setTimeout(function () {
                ct.style.tableLayout = 'fixed';
            }, 10);
        }
    },

    destroy: function () {
        if (this.elNode) {
            Ext.dd.Registry.unregister(this.elNode.id);
        }
        delete this.node;
    },

    collapse: Ext.emptyFn,
    expand: Ext.emptyFn
});

/*!
* Ext JS Library 3.3.1
* Copyright(c) 2006-2010 Sencha Inc.
* licensing@sencha.com
* http://www.sencha.com/license
*/
/**
* @class Ext.ux.tree.TreeGridLoader
* @extends Ext.tree.TreeLoader
*/
Ext.ux.tree.TreeGridLoader = Ext.extend(Ext.tree.TreeLoader, {
    createNode: function (attr) {
        if (!attr.uiProvider) {
            attr.uiProvider = Ext.ux.tree.TreeGridNodeUI;
        }
        return Ext.tree.TreeLoader.prototype.createNode.call(this, attr);
    }
});

/*!
* Ext JS Library 3.3.1
* Copyright(c) 2006-2010 Sencha Inc.
* licensing@sencha.com
* http://www.sencha.com/license
*/
(function () {
    Ext.override(Ext.list.Column, {
        init: function () {
            var types = Ext.data.Types,
                st = this.sortType;

            if (this.type) {
                if (Ext.isString(this.type)) {
                    this.type = Ext.data.Types[this.type.toUpperCase()] || types.AUTO;
                }
            } else {
                this.type = types.AUTO;
            }

            // named sortTypes are supported, here we look them up
            if (Ext.isString(st)) {
                this.sortType = Ext.data.SortTypes[st];
            } else if (Ext.isEmpty(st)) {
                this.sortType = this.type.sortType;
            }
        }
    });

    Ext.tree.Column = Ext.extend(Ext.list.Column, {});
    Ext.tree.NumberColumn = Ext.extend(Ext.list.NumberColumn, {});
    Ext.tree.DateColumn = Ext.extend(Ext.list.DateColumn, {});
    Ext.tree.BooleanColumn = Ext.extend(Ext.list.BooleanColumn, {});

    Ext.reg('tgcolumn', Ext.tree.Column);
    Ext.reg('tgnumbercolumn', Ext.tree.NumberColumn);
    Ext.reg('tgdatecolumn', Ext.tree.DateColumn);
    Ext.reg('tgbooleancolumn', Ext.tree.BooleanColumn);
})();

/*!
* Ext JS Library 3.3.1
* Copyright(c) 2006-2010 Sencha Inc.
* licensing@sencha.com
* http://www.sencha.com/license
*/
/**
* @class Ext.ux.tree.TreeGrid
* @extends Ext.tree.TreePanel
* 
* @xtype treegrid
*/
Ext.ux.tree.TreeGrid = Ext.extend(Ext.tree.TreePanel, {
    rootVisible: false,
    useArrows: true,
    lines: false,
    borderWidth: Ext.isBorderBox ? 0 : 2, // the combined left/right border for each cell
    cls: 'x-treegrid',

    columnResize: true,
    enableSort: true,
    reserveScrollOffset: true,
    enableHdMenu: true,

    columnsText: 'Columns',

    initComponent: function () {
        if (!this.root) {
            this.root = new Ext.tree.AsyncTreeNode({ text: 'Root' });
        }

        // initialize the loader
        var l = this.loader;
        if (!l) {
            l = new Ext.ux.tree.TreeGridLoader({
                dataUrl: this.dataUrl,
                requestMethod: this.requestMethod,
                store: this.store
            });
        } else if (Ext.isObject(l) && !l.load) {
            l = new Ext.ux.tree.TreeGridLoader(l);
        }
        this.loader = l;

        Ext.ux.tree.TreeGrid.superclass.initComponent.call(this);

        this.initColumns();

        if (this.enableSort) {
            this.treeGridSorter = new Ext.ux.tree.TreeGridSorter(this, this.enableSort);
        }

        if (this.columnResize) {
            this.colResizer = new Ext.tree.ColumnResizer(this.columnResize);
            this.colResizer.init(this);
        }

        var c = this.columns;
        if (!this.internalTpl) {
            this.internalTpl = new Ext.XTemplate(
                '<div class="x-grid3-header">',
                '<div class="x-treegrid-header-inner">',
                '<div class="x-grid3-header-offset">',
                '<table style="table-layout: fixed;" cellspacing="0" cellpadding="0" border="0"><colgroup><tpl for="columns"><col /></tpl></colgroup>',
                '<thead><tr class="x-grid3-hd-row">',
                '<tpl for="columns">',
                '<td class="x-grid3-hd x-grid3-cell x-treegrid-hd" style="text-align: {align};" id="', this.id, '-xlhd-{#}">',
                '<div class="x-grid3-hd-inner x-treegrid-hd-inner" unselectable="on">',
                this.enableHdMenu ? '<a class="x-grid3-hd-btn" href="#"></a>' : '',
                '{header}<img class="x-grid3-sort-icon" src="', Ext.BLANK_IMAGE_URL, '" />',
                '</div>',
                '</td></tpl>',
                '</tr></thead>',
                '</table>',
                '</div></div>',
                '</div>',
                '<div class="x-treegrid-root-node">',
                '<table class="x-treegrid-root-table" cellpadding="0" cellspacing="0" style="table-layout: fixed;"></table>',
                '</div>'
            );
        }

        if (!this.colgroupTpl) {
            this.colgroupTpl = new Ext.XTemplate(
                '<colgroup><tpl for="columns"><col style="width: {width}px"/></tpl></colgroup>'
            );
        }
    },

    initColumns: function () {
        var cs = this.columns,
            len = cs.length,
            columns = [],
            i, c;

        for (i = 0; i < len; i++) {
            c = cs[i];
            if (!c.isColumn) {
                c.xtype = c.xtype ? (/^tg/.test(c.xtype) ? c.xtype : 'tg' + c.xtype) : 'tgcolumn';
                c = Ext.create(c);
            }
            c.init(this);
            columns.push(c);

            if (this.enableSort !== false && c.sortable !== false) {
                c.sortable = true;
                this.enableSort = true;
            }
        }

        this.columns = columns;
    },

    onRender: function () {
        Ext.tree.TreePanel.superclass.onRender.apply(this, arguments);

        this.el.addClass('x-treegrid');

        this.outerCt = this.body.createChild({
            cls: 'x-tree-root-ct x-treegrid-ct ' + (this.useArrows ? 'x-tree-arrows' : this.lines ? 'x-tree-lines' : 'x-tree-no-lines')
        });

        this.internalTpl.overwrite(this.outerCt, { columns: this.columns });

        this.mainHd = Ext.get(this.outerCt.dom.firstChild);
        this.innerHd = Ext.get(this.mainHd.dom.firstChild);
        this.innerBody = Ext.get(this.outerCt.dom.lastChild);
        this.innerCt = Ext.get(this.innerBody.dom.firstChild);

        this.colgroupTpl.insertFirst(this.innerCt, { columns: this.columns });

        if (this.hideHeaders) {
            this.el.child('.x-grid3-header').setDisplayed('none');
        }
        else if (this.enableHdMenu !== false) {
            this.hmenu = new Ext.menu.Menu({ id: this.id + '-hctx' });
            if (this.enableColumnHide !== false) {
                this.colMenu = new Ext.menu.Menu({ id: this.id + '-hcols-menu' });
                this.colMenu.on({
                    scope: this,
                    beforeshow: this.beforeColMenuShow,
                    itemclick: this.handleHdMenuClick
                });
                this.hmenu.add({
                    itemId: 'columns',
                    hideOnClick: false,
                    text: this.columnsText,
                    menu: this.colMenu,
                    iconCls: 'x-cols-icon'
                });
            }
            this.hmenu.on('itemclick', this.handleHdMenuClick, this);
        }
    },

    setRootNode: function (node) {
        node.attributes.uiProvider = Ext.ux.tree.TreeGridRootNodeUI;
        node = Ext.ux.tree.TreeGrid.superclass.setRootNode.call(this, node);
        if (this.innerCt) {
            this.colgroupTpl.insertFirst(this.innerCt, { columns: this.columns });
        }
        return node;
    },

    clearInnerCt: function () {
        if (Ext.isIE) {
            var dom = this.innerCt.dom;
            while (dom.firstChild) {
                dom.removeChild(dom.firstChild);
            }
        } else {
            Ext.ux.tree.TreeGrid.superclass.clearInnerCt.call(this);
        }
    },

    initEvents: function () {
        Ext.ux.tree.TreeGrid.superclass.initEvents.apply(this, arguments);

        this.mon(this.innerBody, 'scroll', this.syncScroll, this);
        this.mon(this.innerHd, 'click', this.handleHdDown, this);
        this.mon(this.mainHd, {
            scope: this,
            mouseover: this.handleHdOver,
            mouseout: this.handleHdOut
        });
    },

    onResize: function (w, h) {
        Ext.ux.tree.TreeGrid.superclass.onResize.apply(this, arguments);

        var bd = this.innerBody.dom;
        var hd = this.innerHd.dom;

        if (!bd) {
            return;
        }

        if (Ext.isNumber(h)) {
            bd.style.height = this.body.getHeight(true) - hd.offsetHeight + 'px';
        }

        if (Ext.isNumber(w)) {
            var sw = Ext.num(this.scrollOffset, Ext.getScrollBarWidth());
            if (this.reserveScrollOffset || ((bd.offsetWidth - bd.clientWidth) > 10)) {
                this.setScrollOffset(sw);
            } else {
                var me = this;
                setTimeout(function () {
                    me.setScrollOffset(bd.offsetWidth - bd.clientWidth > 10 ? sw : 0);
                }, 10);
            }
        }
    },

    updateColumnWidths: function () {
        var cols = this.columns,
            colCount = cols.length,
            groups = this.outerCt.query('colgroup'),
            groupCount = groups.length,
            c, g, i, j;

        for (i = 0; i < colCount; i++) {
            c = cols[i];
            for (j = 0; j < groupCount; j++) {
                g = groups[j];
                g.childNodes[i].style.width = (c.hidden ? 0 : c.width) + 'px';
            }
        }

        for (i = 0, groups = this.innerHd.query('td'), len = groups.length; i < len; i++) {
            c = Ext.fly(groups[i]);
            if (cols[i] && cols[i].hidden) {
                c.addClass('x-treegrid-hd-hidden');
            }
            else {
                c.removeClass('x-treegrid-hd-hidden');
            }
        }

        var tcw = this.getTotalColumnWidth();
        Ext.fly(this.innerHd.dom.firstChild).setWidth(tcw + (this.scrollOffset || 0));
        this.outerCt.select('table').setWidth(tcw);
        this.syncHeaderScroll();
    },

    getVisibleColumns: function () {
        var columns = [],
            cs = this.columns,
            len = cs.length,
            i;

        for (i = 0; i < len; i++) {
            if (!cs[i].hidden) {
                columns.push(cs[i]);
            }
        }
        return columns;
    },

    getTotalColumnWidth: function () {
        var total = 0;
        for (var i = 0, cs = this.getVisibleColumns(), len = cs.length; i < len; i++) {
            total += cs[i].width;
        }
        return total;
    },

    setScrollOffset: function (scrollOffset) {
        this.scrollOffset = scrollOffset;
        this.updateColumnWidths();
    },

    // private
    handleHdDown: function (e, t) {
        var hd = e.getTarget('.x-treegrid-hd');

        if (hd && Ext.fly(t).hasClass('x-grid3-hd-btn')) {
            var ms = this.hmenu.items,
                cs = this.columns,
                index = this.findHeaderIndex(hd),
                c = cs[index],
                sort = c.sortable;

            e.stopEvent();
            Ext.fly(hd).addClass('x-grid3-hd-menu-open');
            this.hdCtxIndex = index;

            this.fireEvent('headerbuttonclick', ms, c, hd, index);

            this.hmenu.on('hide', function () {
                Ext.fly(hd).removeClass('x-grid3-hd-menu-open');
            }, this, { single: true });

            this.hmenu.show(t, 'tl-bl?');
        }
        else if (hd) {
            var index = this.findHeaderIndex(hd);
            this.fireEvent('headerclick', this.columns[index], hd, index);
        }
    },

    // private
    handleHdOver: function (e, t) {
        var hd = e.getTarget('.x-treegrid-hd');
        if (hd && !this.headersDisabled) {
            index = this.findHeaderIndex(hd);
            this.activeHdRef = t;
            this.activeHdIndex = index;
            var el = Ext.get(hd);
            this.activeHdRegion = el.getRegion();
            el.addClass('x-grid3-hd-over');
            this.activeHdBtn = el.child('.x-grid3-hd-btn');
            if (this.activeHdBtn) {
                this.activeHdBtn.dom.style.height = (hd.firstChild.offsetHeight - 1) + 'px';
            }
        }
    },

    // private
    handleHdOut: function (e, t) {
        var hd = e.getTarget('.x-treegrid-hd');
        if (hd && (!Ext.isIE || !e.within(hd, true))) {
            this.activeHdRef = null;
            Ext.fly(hd).removeClass('x-grid3-hd-over');
            hd.style.cursor = '';
        }
    },

    findHeaderIndex: function (hd) {
        hd = hd.dom || hd;
        var cs = hd.parentNode.childNodes;
        for (var i = 0, c; c = cs[i]; i++) {
            if (c == hd) {
                return i;
            }
        }
        return -1;
    },

    // private
    beforeColMenuShow: function () {
        var cols = this.columns,
            colCount = cols.length,
            i, c;
        this.colMenu.removeAll();
        for (i = 1; i < colCount; i++) {
            c = cols[i];
            if (c.hideable !== false) {
                this.colMenu.add(new Ext.menu.CheckItem({
                    itemId: 'col-' + i,
                    text: c.header,
                    checked: !c.hidden,
                    hideOnClick: false,
                    disabled: c.hideable === false
                }));
            }
        }
    },

    // private
    handleHdMenuClick: function (item) {
        var index = this.hdCtxIndex,
            id = item.getItemId();

        if (this.fireEvent('headermenuclick', this.columns[index], id, index) !== false) {
            index = id.substr(4);
            if (index > 0 && this.columns[index]) {
                this.setColumnVisible(index, !item.checked);
            }
        }

        return true;
    },

    setColumnVisible: function (index, visible) {
        this.columns[index].hidden = !visible;
        this.updateColumnWidths();
    },

    /**
	* Scrolls the grid to the top
	*/
    scrollToTop: function () {
        this.innerBody.dom.scrollTop = 0;
        this.innerBody.dom.scrollLeft = 0;
    },

    // private
    syncScroll: function () {
        this.syncHeaderScroll();
        var mb = this.innerBody.dom;
        this.fireEvent('bodyscroll', mb.scrollLeft, mb.scrollTop);
    },

    // private
    syncHeaderScroll: function () {
        var mb = this.innerBody.dom;
        this.innerHd.dom.scrollLeft = mb.scrollLeft;
        this.innerHd.dom.scrollLeft = mb.scrollLeft; // second time for IE (1/2 time first fails, other browsers ignore)
    },

    registerNode: function (n) {
        Ext.ux.tree.TreeGrid.superclass.registerNode.call(this, n);
        if (!n.uiProvider && !n.isRoot && !n.ui.isTreeGridNodeUI) {
            n.ui = new Ext.ux.tree.TreeGridNodeUI(n);
        }
    }
});

Ext.reg('treegrid', Ext.ux.tree.TreeGrid);

// *********************** Ext.ux.NumericField ***********************
// Used for currency input fields
// http://www.sencha.com/forum/showthread.php?125935-Number-field-with-currency-symbol-thousand-separator-with-international-support
// http://stackoverflow.com/questions/5118111/extjs-extending-numberfield-to-currencyfield
// *******************************************************************
Ext.ux.NumericField = function (config) {

    var defaultConfig =
    {
        style: 'text-align: right;'
    };

    Ext.form.TextField.superclass.constructor.call(this, Ext.apply(defaultConfig, config));

    // Setup the list of acceptable characters.
    this.allowedChars = ['.', ',', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '\n', '\t', '-'];
    this.onFocus = this.onFocus.createSequence(this.onFocus);
    this.addListener('blur', function () {
        var val = this.getValue();
        if (isNaN(val)) {
            var rex = /[\uFF10-\uFF19]/g;
            val = val.replace(rex, function (ch) {
                return String.fromCharCode(ch.charCodeAt(0) - 65248);
            });
            this.setValue(val);
        }
    });
};

function getNumberFieldInfo() {

    // The Ext.form.NumberField.thousandSeparator and Ext.form.NumberField.decimalSeparator characters were coming from 
    // the OS's cultureinfo for the language used by the browser in GetClientLocaleInfo.aspx.
    // In some cases, there is a discrepancy between this separator and the one defined in the javascript locale files.
    // For example, Russian and French return a space, however the javascript locale files do not support spaces.
    // This function uses the format from the appropriate locale file to get these separator characters.
    if (Ext.form.NumberField.thousandSeparator === undefined || Ext.form.NumberField.decimalSeparator === undefined) {

        var format = "0,000.";
        if (Ext.grid.NumberColumn !== undefined && Ext.grid.NumberColumn.prototype.format !== undefined)
            format = Ext.grid.NumberColumn.prototype.format;

        var separators = {
            dec: '',
            thou: ''
        }
        getNumberSeparators(format, separators);
        if (separators.thou == '') {
            if (separators.dec == ',')
                separators.thou = '.';
            else
                separators.thou = ',';
        }

        // Associate the corrected values.
        Ext.form.NumberField.thousandSeparator = separators.thou;
        Ext.form.NumberField.decimalSeparator = separators.dec;
    }
}

function getNumberSeparators(value, separators) {

    separators.thou = '';
    separators.dec = '';

    var format = value.replace("/i", "").replace(String.fromCharCode(160), " ");

    // Iterate backwards and assign values as necessary.
    for (var i = format.length - 1; i >= 0; i--) {
        var cur = format.charAt(i);
        if (cur == ' ' || cur == ',' || cur == '.') {
            if (separators.dec == '')
                separators.dec = cur;
            else
                separators.thou = cur;
        }
    }
}

Ext.extend(Ext.ux.NumericField, Ext.form.TextField,
    {
        formatNumberLocale: function (v) {
            getNumberFieldInfo();

            // This method will strip any english strings
            // of their identity, making them internationalized for database
            // and business logic purposes only.
            var decimal = Ext.form.NumberField.decimalSeparator || '.';
            var thousands = Ext.form.NumberField.thousandSeparator || ',';

            // Some code to fix a known issue with char code 160.
            thousands = thousands.replace(String.fromCharCode(160), ' ');
            v = (v || '0').toString();

            // Strip the number of the thousands.
            for (var i = 0; i < v.length; i++)
                v = v.replace(',', '');

            // Replace the decimal separator.
            for (var i = 0; i < v.length; i++)
                v = v.replace('.', decimal);

            return v;
        },
        formatNumberEN: function (v) {
            getNumberFieldInfo();

            // This method will strip any internationalized strings
            // of their identity, making them english for database
            // and business logic purposes only.
            var decimal = Ext.form.NumberField.decimalSeparator || '.';
            var thousands = Ext.form.NumberField.thousandSeparator || ',';

            // Some code to fix a known issue with char code 160.
            thousands = thousands.replace(String.fromCharCode(160), ' ');
            v = (v || '0').toString();

            // Strip the number of the thousands.
            for (var i = 0; i < v.length; i++)
                v = v.replace(thousands.toString(), '');

            // Replace the decimal separator.
            for (var i = 0; i < v.length; i++)
                v = v.replace(decimal.toString(), '.');

            return v;
        },
        listeners: {
            keypress: function (self, evt) {
                if (evt.shiftKey || evt.altKey || evt.ctrlKey) return;
                var code = evt.charCode || evt.keyCode;
                var pass = false;
                // Verify the thing is allowed.
                for (var i = 0; i < self.allowedChars.length; i++) {
                    if (code == self.allowedChars[i].toLowerCase().charCodeAt()) {
                        pass = true;
                    }
                }

                // To fix a FF specific issue and making a way to go through manually for BackSpace, Left Arrow and Right Arrow keys
                if (Ext.isGecko) {
                    if (code == 8 || code == 37 || code == 39) {
                        return true;
                    }
                }

                // Validate.
                if (!pass) {
                    evt.preventDefault();
                    return false;
                }

                return true;
            },
            keydown: function (self, evt) {
                // set dirty only when existing value gets changed
                var code = evt.charCode || evt.keyCode;
                if (code == 8 || code == 46 || self.isDirty())
                    editWindow.setDataDirty();
            },
            blur: function () {
                // Format currency fields to 2 decimal places
                if (this.isCurrency) {
                    // try to format the number into english.
                    var val = this.formatNumberEN(this.getRawValue());

                    // Attempt to parse the number.
                    var p_val = parseFloat(val);

                    // Check if it was successful.
                    if (!isNaN(p_val)) {
                        this.setRawValue(Ext.util.Format.number(jMath.toFixed(p_val, 2)));
                    }
                }
            },
            afterrender: function (self) {
                self.fireEvent('blur');
            }

        },
        getValue: function () {
            // try to format the number into english.
            var val = this.formatNumberEN(this.getRawValue());

            // Attempt to parse the number.
            var p_val = parseFloat(val);

            // Check if it was successful.
            if (!isNaN(p_val)) {
                return p_val;
            }

            // Otherwise, we have a bigger issue!
            p_val = parseFloat(this.getRawValue());

            // Check if it was successful.
            if (!isNaN(p_val)) {
                return p_val;
            }

            // Lastly, we have a huge issue - so just return the string.
            // ARGUABLY: We should consider returning 0 instead?
            return this.getRawValue();
        },
        setValue: function (v) {
            if (v === undefined || v === null || v === '') {
                this.setRawValue(0);
                this.fireEvent('blur');
                return;
            }
            var number = parseFloat(v);
            if (isNaN(number) || number == '') number = 0;

            var value = this.formatNumberLocale(number);
            this.setRawValue(value);
            this.fireEvent('blur');
        }
    });
Ext.reg('numericfield', Ext.ux.NumericField);
// *****************************************************************


// *********************** Ext.ux.NumericBlank ***********************
Ext.ux.NumericBlank = function (config) {
    Ext.ux.NumericField.superclass.constructor.call(this);
};

Ext.extend(Ext.ux.NumericBlank, Ext.ux.NumericField,
    {
        getValue: function () {

            var raw = this.getRawValue();
            if (raw === undefined || raw === null || raw === '')
                return '';                  // <-- this is the difference to the base class, allow blanks...

            // try to format the number into english.
            var val = this.formatNumberEN(raw);

            // Attempt to parse the number.
            var p_val = parseFloat(val);

            // Check if it was successful.
            if (!isNaN(p_val)) {
                return p_val;
            }

            // Otherwise, we have a bigger issue!
            p_val = parseFloat(raw);

            // Check if it was successful.
            if (!isNaN(p_val)) {
                return p_val;
            }

            // Lastly, we have a huge issue - so just return the string.
            // ARGUABLY: We should consider returning 0 instead?
            return raw;
        },
        setValue: function (v) {
            if (v === undefined || v === null || v === '') {
                this.setRawValue("");     // <-- this is the difference to the base class, allow blanks...
                this.fireEvent('blur');
                return;
            }
            var number = parseFloat(v);
            if (isNaN(number) || number == '') number = 0;

            var value = this.formatNumberLocale(number);
            this.setRawValue(value);
            this.fireEvent('blur');
        }
    });
Ext.reg('numericblank', Ext.ux.NumericBlank);

// *******************************************************************

/**
* @class Ext.ux.form.FileUploadField
* @extends Ext.form.TextField
* Creates a file upload field.
* @xtype fileuploadfield
*/
Ext.ux.form.FileUploadField = Ext.extend(Ext.form.TextField, {
    /**
	* @cfg {String} buttonText The button text to display on the upload button (defaults to
	* 'Browse...').  Note that if you supply a value for {@link #buttonCfg}, the buttonCfg.text
	* value will be used instead if available.
	*/
    buttonText: 'Browse...',
    /**
	* @cfg {Boolean} buttonOnly True to display the file upload field as a button with no visible
	* text field (defaults to false).  If true, all inherited TextField members will still be available.
	*/
    buttonOnly: false,
    /**
	* @cfg {Number} buttonOffset The number of pixels of space reserved between the button and the text field
	* (defaults to 3).  Note that this only applies if {@link #buttonOnly} = false.
	*/
    buttonOffset: 3,
    /**
	* @cfg {Object} buttonCfg A standard {@link Ext.Button} config object.
	*/

    // private
    readOnly: true,

    /**
	* @hide
	* @method autoSize
	*/
    autoSize: Ext.emptyFn,

    // private
    initComponent: function () {
        Ext.ux.form.FileUploadField.superclass.initComponent.call(this);

        this.addEvents(
            /**
            * @event fileselected
            * Fires when the underlying file input field's value has changed from the user
            * selecting a new file from the system file selection dialog.
            * @param {Ext.ux.form.FileUploadField} this
            * @param {String} value The file value returned by the underlying file input field
            */
            'fileselected'
        );
    },

    // private
    onRender: function (ct, position) {
        Ext.ux.form.FileUploadField.superclass.onRender.call(this, ct, position);

        this.wrap = this.el.wrap({ cls: 'x-form-field-wrap x-form-file-wrap' });
        this.el.addClass('x-form-file-text');
        this.el.dom.removeAttribute('name');
        this.createFileInput();

        var btnCfg = Ext.applyIf(this.buttonCfg || {}, {
            text: this.buttonText
        });
        this.button = new Ext.Button(Ext.apply(btnCfg, {
            renderTo: this.wrap,
            cls: 'x-form-file-btn' + (btnCfg.iconCls ? ' x-btn-icon' : ''),
            id: 'btnSelectFile'
        }));

        if (this.buttonOnly) {
            this.el.hide();
            this.wrap.setWidth(this.button.getEl().getWidth());
        }

        this.bindListeners();
        this.resizeEl = this.positionEl = this.wrap;
    },

    bindListeners: function () {
        this.fileInput.on({
            scope: this,
            mouseenter: function () {
                this.button.addClass(['x-btn-over', 'x-btn-focus'])
            },
            mouseleave: function () {
                this.button.removeClass(['x-btn-over', 'x-btn-focus', 'x-btn-click'])
            },
            mousedown: function () {
                this.button.addClass('x-btn-click')
            },
            mouseup: function () {
                this.button.removeClass(['x-btn-over', 'x-btn-focus', 'x-btn-click'])
            },
            change: function () {
                var v = this.fileInput.dom.value;
                this.setValue(v);
                this.fireEvent('fileselected', this, v);
            }
        });
    },

    createFileInput: function () {
        this.fileInput = this.wrap.createChild({
            id: this.getFileInputId(),
            name: this.name || this.getId(),
            cls: 'x-form-file',
            tag: 'input',
            type: 'file',
            size: 1
        });
    },

    reset: function () {
        this.fileInput.remove();
        this.createFileInput();
        this.bindListeners();
        Ext.ux.form.FileUploadField.superclass.reset.call(this);
    },

    // private
    getFileInputId: function () {
        return this.id + '-file';
    },

    // private
    onResize: function (w, h) {
        Ext.ux.form.FileUploadField.superclass.onResize.call(this, w, h);

        this.wrap.setWidth(w);

        if (!this.buttonOnly) {
            var w = this.wrap.getWidth() - this.button.getEl().getWidth() - this.buttonOffset;
            this.el.setWidth(w);
        }
    },

    // private
    onDestroy: function () {
        Ext.ux.form.FileUploadField.superclass.onDestroy.call(this);
        Ext.destroy(this.fileInput, this.button, this.wrap);
    },

    onDisable: function () {
        Ext.ux.form.FileUploadField.superclass.onDisable.call(this);
        this.doDisable(true);
    },

    onEnable: function () {
        Ext.ux.form.FileUploadField.superclass.onEnable.call(this);
        this.doDisable(false);

    },

    // private
    doDisable: function (disabled) {
        this.fileInput.dom.disabled = disabled;
        this.button.setDisabled(disabled);
    },


    // private
    preFocus: Ext.emptyFn,

    // private
    alignErrorIcon: function () {
        this.errorIcon.alignTo(this.wrap, 'tl-tr', [2, 0]);
    }

});

Ext.reg('fileuploadfield', Ext.ux.form.FileUploadField);

// backwards compat
Ext.form.FileUploadField = Ext.ux.form.FileUploadField;


/*!
* Ext JS Library 3.0.0
* Copyright(c) 2006-2009 Ext JS, LLC
* licensing@extjs.com
* http://www.extjs.com/license
* 
* Modifications by Mykhail Stadnik <http://mikhailstadnik.com>:
*  - Nesting grids support added
*/
Ext.ns('Ext.ux.grid');

/**
* @class Ext.ux.grid.RowExpander
* @extends Ext.util.Observable
* Plugin (ptype = 'rowexpander') that adds the ability to have a Column in a grid which enables
* a second row body which expands/contracts.  The expand/contract behavior is configurable to react
* on clicking of the column, double click of the row, and/or hitting enter while a row is selected.
*
* @ptype rowexpander
*/
Ext.ux.grid.RowExpander = Ext.extend(Ext.util.Observable, {
    /**
	* @cfg {Boolean} expandOnEnter
	* <tt>true</tt> to toggle selected row(s) between expanded/collapsed when the enter
	* key is pressed (defaults to <tt>true</tt>).
	*/
    expandOnEnter: true,
    /**
	* @cfg {Boolean} expandOnDblClick
	* <tt>true</tt> to toggle a row between expanded/collapsed when double clicked
	* (defaults to <tt>true</tt>).
	*/
    expandOnDblClick: true,

    header: '',
    width: 20,
    sortable: false,
    fixed: true,
    hideable: false,
    menuDisabled: true,
    dataIndex: '',
    id: 'expander',
    lazyRender: true,
    enableCaching: true,

    constructor: function (config) {
        Ext.apply(this, config);

        this.addEvents({
            /**
			* @event beforeexpand
			* Fires before the row expands. Have the listener return false to prevent the row from expanding.
			* @param {Object} this RowExpander object.
			* @param {Object} Ext.data.Record Record for the selected row.
			* @param {Object} body body element for the secondary row.
			* @param {Number} rowIndex The current row index.
			*/
            beforeexpand: true,
            /**
			* @event expand
			* Fires after the row expands.
			* @param {Object} this RowExpander object.
			* @param {Object} Ext.data.Record Record for the selected row.
			* @param {Object} body body element for the secondary row.
			* @param {Number} rowIndex The current row index.
			*/
            expand: true,
            /**
			* @event beforecollapse
			* Fires before the row collapses. Have the listener return false to prevent the row from collapsing.
			* @param {Object} this RowExpander object.
			* @param {Object} Ext.data.Record Record for the selected row.
			* @param {Object} body body element for the secondary row.
			* @param {Number} rowIndex The current row index.
			*/
            beforecollapse: true,
            /**
			* @event collapse
			* Fires after the row collapses.
			* @param {Object} this RowExpander object.
			* @param {Object} Ext.data.Record Record for the selected row.
			* @param {Object} body body element for the secondary row.
			* @param {Number} rowIndex The current row index.
			*/
            collapse: true
        });

        Ext.ux.grid.RowExpander.superclass.constructor.call(this);

        if (this.tpl) {
            if (typeof this.tpl == 'string') {
                this.tpl = new Ext.Template(this.tpl);
            }
            this.tpl.compile();
        }

        this.state = {};
        this.bodyContent = {};
    },

    getRowClass: function (record, rowIndex, p, ds) {
        p.cols = p.cols - 1;
        var content = this.bodyContent[record.id];
        if (!content && !this.lazyRender) {
            content = this.getBodyContent(record, rowIndex);
        }
        if (content) {
            p.body = content;
        }
        return this.state[record.id] ? 'x-grid3-row-expanded' : 'x-grid3-row-collapsed';
    },

    init: function (grid) {
        this.grid = grid;

        var view = grid.getView();
        view.getRowClass = this.getRowClass.createDelegate(this);

        view.enableRowBody = true;


        grid.on('render', this.onRender, this);
        grid.on('destroy', this.onDestroy, this);
    },

    // @private
    onRender: function () {
        var grid = this.grid;
        var mainBody = grid.getView().mainBody;
        mainBody.on('mousedown', this.onMouseDown, this, { delegate: '.x-grid3-row-expander' });
        if (this.expandOnEnter) {
            this.keyNav = new Ext.KeyNav(this.grid.getGridEl(), {
                'enter': this.onEnter,
                scope: this
            });
        }
        if (this.expandOnDblClick) {
            grid.on('rowdblclick', this.onRowDblClick, this);
        }
    },

    // @private    
    onDestroy: function () {
        if (this.keyNav) {
            this.keyNav.disable();
            delete this.keyNav;
        }
        /*
		* A majority of the time, the plugin will be destroyed along with the grid,
		* which means the mainBody won't be available. On the off chance that the plugin
		* isn't destroyed with the grid, take care of removing the listener.
		*/
        var mainBody = this.grid.getView().mainBody;
        if (mainBody) {
            mainBody.un('mousedown', this.onMouseDown, this);
        }
    },
    // @private
    onRowDblClick: function (grid, rowIdx, e) {
        this.toggleRow(rowIdx);
    },

    onEnter: function (e) {
        var g = this.grid;
        var sm = g.getSelectionModel();
        var sels = sm.getSelections();
        for (var i = 0, len = sels.length; i < len; i++) {
            var rowIdx = g.getStore().indexOf(sels[i]);
            this.toggleRow(rowIdx);
        }
    },

    getBodyContent: function (record, index) {
        if (!this.enableCaching) {
            return this.tpl.apply(record.data);
        }
        var content = this.bodyContent[record.id];
        if (!content) {
            content = this.tpl.apply(record.data);
            this.bodyContent[record.id] = content;
        }
        return content;
    },

    onMouseDown: function (e, t) {
        e.stopEvent();
        var row = e.getTarget('.x-grid3-row');
        this.toggleRow(row);
    },

    renderer: function (v, p, record) {
        p.cellAttr = 'rowspan="2"';
        return '<div class="x-grid3-row-expander">&#160;</div>';
    },

    beforeExpand: function (record, body, rowIndex) {
        if (this.fireEvent('beforeexpand', this, record, body, rowIndex) !== false) {
            if (this.tpl && this.lazyRender) {
                body.innerHTML = this.getBodyContent(record, rowIndex);
            }
            return true;
        } else {
            return false;
        }
    },

    toggleRow: function (row) {
        if (typeof row == 'number') {
            row = this.grid.view.getRow(row);
        }
        this[Ext.fly(row).hasClass('x-grid3-row-collapsed') ? 'expandRow' : 'collapseRow'](row);
    },

    expandRow: function (row) {
        if (typeof row == 'number') {
            row = this.grid.view.getRow(row);
        }
        var record = this.grid.store.getAt(row.rowIndex);
        var body = Ext.DomQuery.selectNode('tr:nth(2) div.x-grid3-row-body', row);
        if (this.beforeExpand(record, body, row.rowIndex)) {
            this.state[record.id] = true;
            Ext.fly(row).replaceClass('x-grid3-row-collapsed', 'x-grid3-row-expanded');
            this.fireEvent('expand', this, record, body, row.rowIndex);
        }
    },

    collapseRow: function (row) {
        if (typeof row == 'number') {
            row = this.grid.view.getRow(row);
        }
        var record = this.grid.store.getAt(row.rowIndex);
        var body = Ext.fly(row).child('tr:nth(1) div.x-grid3-row-body', true);
        if (this.fireEvent('beforecollapse', this, record, body, row.rowIndex) !== false) {
            this.state[record.id] = false;
            Ext.fly(row).replaceClass('x-grid3-row-expanded', 'x-grid3-row-collapsed');
            this.fireEvent('collapse', this, record, body, row.rowIndex);
        }
    }
});

Ext.preg('rowexpander', Ext.ux.grid.RowExpander);

//backwards compat
Ext.grid.RowExpander = Ext.ux.grid.RowExpander;


// JMC: 2012/03/23
// Created a custom Calendar object derrived from
// a grid (of all things).

// Define the namespace for our new ux object.
Ext.namespace('Ext.ux');
// Create the basic constructor
Ext.ux.OrxCalendar = function (config) {
    // Setup some defaults for the config
    // ToDo: This
    // Apply the configuration object to our parent class.
    Ext.ux.OrxCalendar.superclass.constructor.call(this, config);
};

var monthString = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
var dayOfWeekString = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

// Define the parent class for our new object. Specify any default values.
Ext.extend(Ext.ux.OrxCalendar, Ext.grid.EditorGridPanel, {

    initComponent: function () {
        var eventDays = [];
        var closedEventDays = [];

        var orxCalendarFields = new Array();



        for (var i = 0; i < dayOfWeekString.length; i++) {
            orxCalendarFields.push({
                // Define the header
                id: dayOfWeekString[i],
                header: dayOfWeekString[i],
                sortable: false,
                width: 102,
                height: 20,
                // Define the renderer.
                renderer: function (value, metaData, record, rowIndex, colIndex, store) {

                    var event = false;
                    var closed = false;
                    try {
                        var cal = config;
                        for (var i = 0; i < eventDays.length; i++) {
                            if (eventDays[i].day == value && eventDays[i].month == cal.month && eventDays[i].year == cal.year) {
                                event = true;
                            }
                        }
                        for (var i = 0; i < closedEventDays.length; i++) {
                            if (closedEventDays[i].day == value && closedEventDays[i].month == cal.month && closedEventDays[i].year == cal.year) {
                                closed = true;
                            }
                        }
                    } catch (err) { }

                    metaData.css = (event) ? "orx-calendar-cell-event" :
                        (closed) ? "orx-calendar-cell-closed" : "orx-calendar-cell";
                    if (value == 0) value = "";

                    return "<div class='orx-calendar-day'>" + value + "</div>";
                }
            });
        }

        var arrayStore = new Ext.data.ArrayStore({
            id: 'calendarStore',
            autoDestroy: true,
            fields: [{ name: '0', type: 'int' }, { name: '1', type: 'int' }, { name: '2', type: 'int' }, { name: '3', type: 'int' }, { name: '4', type: 'int' }, { name: '5', type: 'int' }, { name: '6', type: 'int' }]
        })

        function loadMonth(m, y, supress) {
            if (supress === undefined) supress = false;

            // Update the variables for the calendar.
            // update config.<prop> instead of this.<prop>
            config.month = m;
            config.year = y;
            // Create some variables to store the result in.
            var weeks = [], days = [];
            // Grab the current date time object.
            var date = new Date(y, m, 1);
            // Figure out the offset (if any) for the first day of the week.
            if (date.getDay() != 0) {
                // If the week starts after sunday, derrive the offset for the day-of-week.
                for (var i = date.getDay(); i < 7; i++) {
                    // The day of the week (days[i]) = the current day ( date.getDay()
                    days[i] = date.getDate();
                    // Add a day to the datetime object.
                    date.setDate(date.getDate() + 1);
                }
                // Store the first record.
                weeks[weeks.length] = days;
                // Reset the days variable.
                days = [];
            }
            // Iterate through the remaining days.
            for (var i = date.getDay(); i < 31; i++) {
                // Add the remaining day to our list.
                days[days.length] = date.getDate();
                // If the list is full
                if (days.length == 7) {
                    // Add it to the record list.
                    weeks[weeks.length] = days;
                    // Reset the variable.
                    days = [];
                }
                // Incriment the day.
                date.setDate(date.getDate() + 1);
                // Make sure we haven't overflowed to the next month.
                if (date.getMonth() != m)
                    // If we did overflow, break out.
                    break;
            }
            // If there Are unsaved days left
            if (days.length > 0) {
                // Add the remaining to the list.
                weeks[weeks.length] = days;
            }
            // Grab the store and then load up the data.
            arrayStore.loadData(weeks);
            // Update the header
            monthHeader.setHeaderText(monthString[m] + ", " + y);
            // Trigger the update
            var self = Ext.getCmp('OrxCalendar1');
            if (!supress)
                self.fireEvent("datechanged", m, y);
        }

        function nextMonth() {
            // Incriment the month variable.
            config.month = config.month + 1;
            // If we are overflowing into the next month.
            if (config.month > 11) {
                // Make it reset to January
                config.month = 0;
                // Incriment the year.
                config.year = config.year + 1;
            }

            var self = Ext.getCmp('OrxCalendar1');
            self.month = config.month;
            self.year = config.year;

            // Load the data.
            loadMonth(config.month, config.year);
        }

        function previousMonth() {
            // Decrement the month variable.
            config.month = config.month - 1;
            // If we are overflowing into the previous month.
            if (config.month < 0) {
                // Make it reset to December
                config.month = 11;
                // Decrement the year.
                config.year = config.year - 1;
            }

            var self = Ext.getCmp('OrxCalendar1');
            self.month = config.month;
            self.year = config.year;

            // Load the data.
            loadMonth(config.month, config.year);
        }

        var monthHeader = new Ext.Button({
            scale: 'large',
            text: '',
            width: 640,
            setHeaderText: function (val) {
                this.setText("<span style='font-weight:bold;font-size:medium'>" + val + "</span>");
            }
        });

        var config = {
            // Custom Variables
            month: 2,
            year: 2012,
            day: 1,

            // Cell indexes
            selectedX: 0,
            selectedY: 0,

            setEvents: function (days) {
                // Schema for days: { day: 28, month: 3, year: 2012 }
                eventDays = days;
            },
            setClosedEvents: function (days) {
                closedEventDays = days;
            },
            // Overloads
            id: 'orxCalendar',
            tbar: new Ext.Toolbar({
                items: [
                    {
                        handler: previousMonth,
                        scale: 'large',
                        tooltip: ___('PREVIOUS_TEXT'),
                        icon: '/Content/images/icons/33.png'
                    }
                    , monthHeader
                    , '->'
                    , {
                        handler: nextMonth,
                        tooltip: ___('NEXT_TEXT'),
                        scale: 'large',
                        icon: '/Content/images/icons/29.png'
                    }
                ]
            }),

            colModel: new Ext.grid.ColumnModel({
                columns: orxCalendarFields,
                defaultSortable: false
            }),

            store: arrayStore,
            enableHdMenu: false,
            enableColumnMove: false,
            enableColumnHide: false,

            listeners: {
                // Custom event
                datechanged: function (month, year) {
                    this.month = month;
                    this.year = year;
                    return month + "/1/" + year;
                },
                viewready: function () {
                    var date = new Date();
                    this.month = date.getMonth();
                    this.year = date.getFullYear();
                    // Load the grid.
                    loadMonth(this.month, this.year, true);
                },
                cellclick: function (grid, row, col, evt) {
                    //var record = this.getStore().getAt(row);
                    //var day = record.get(col);
                    //config.day = day;

                    //this.selectedX = col;
                    //this.selectedY = row;

                    //var newDate = config.year + "/" + config.month + "/" + config.day;
                    //this.fireEvent("datechanged", new Date(newDate));
                }
            }
        };

        Ext.apply(this, Ext.apply(this.initialConfig, config));
        // call parent
        Ext.ux.OrxCalendar.superclass.initComponent.apply(this, arguments);
    }
});